/* eslint-disable */

/*
This is new algorithm test
*/

import {debounce} from "../debounce";
import * as THREE from "three";

import vertexShaderFile from "./shaders/vertex.js";
import fragmentShaderFile from "./shaders/fragment.js";

import {
	Chart, LineController, LineElement, PointElement, LinearScale, Title, CategoryScale, Tooltip,
} from "chart.js";

Chart.register(LineController, LineElement, PointElement, LinearScale, Title, CategoryScale, Tooltip);

import universitiesAnimation from "./universities-animation";
import circlesCharts from "./circles-charts";
import barCharts from "./bar-charts";
import helpers from "../helpers";
import videoLoader from '../modules/videoLoader';

const stepSize = 250;
/**
 *  UTILS ->
 **/
//
// Extend array functionality
Array.prototype.max = function () {
	return Math.max.apply(null, this);
};

const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

const telegraphChart = {
	chart: null, isShowAnnotationLine: true,
};


let clientWidth = document.body.clientWidth;

function fixedSection() {
	console.log('fixedSection');
	const pin = document.querySelectorAll('.js-pin-bottom');

	gsap.utils.toArray(pin).forEach((panel, index) => {
		const nextEl = panel.nextElementSibling
		const container = panel.querySelector('.container');
		const offsetHeight = container.offsetHeight;
		panel.style.height = `${offsetHeight}px`;


		const enter = () => {
			container.classList.add('fixed-section');
			nextEl.classList.add('z-index');
		}

		const leave = () => {
			container.classList.remove('fixed-section');
			nextEl.classList.remove('z-index');
		}

		ScrollTrigger.create({
			refreshPriority: 1,
			trigger: panel,
			start: 'bottom bottom',
			end: `bottom start`,
			pin: false,
			id: 'fixed-2',
			markers: false,
			invalidateOnRefresh: true,
			scrub: true,

			onEnter: () => {
				enter();
			},

			onEnterBack: () => {
				enter()
			},

			onLeaveBack() {
				leave();
			},

			onLeave() {
				leave();
			},
		});
	});

}


function setstylePersone(sizes) {
	const canvas = document.querySelector('.webgl');
	const height = canvas.clientHeight;

	console.log(canvas.getBoundingClientRect());
	const personPicEl = document.querySelectorAll(".person-effect__img, .vernarskaya-block__pic, .vernarskaya-block, .js-vernarskaya .person__pic, .js-pirogov .person__pic, .two-camps__pics-row, .two-camps.js-two-camps-fixed");

	const personPicElss = document.querySelectorAll(".two-camps.js-two-camps-fixed");
	const personPicEls = document.querySelectorAll(".js-vernarskaya .person__pic, .js-pirogov .person__pic");


	personPicEl.forEach((element, i) => {
		element.classList.add(`var-${i}`);
		element.classList.add('test');
		const root = document.querySelector(':root');
		root.style.setProperty(`--top-${i}`, `${(height / 2) - (element.clientHeight / 2)}px`);
	});
}

/**
 *  UTILS <-
 **/

// Init animation for "amount of enterpreneurs" chart
function initEnterpreneursAnimation() {
	const chartBlockEl = document.querySelector(".js-enterpreneurs-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley block
		const trolleyWrapper = chartBlockEl.closest(".trolley");

		const chartBlockWrapper = chartBlockEl.closest(".chart-block-wrapper");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");

		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock;

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 91,
			invalidateOnRefresh: true, // id: 'fixed',
			markers: false,
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll + 60} center` : `top-=${pinOffset - 450} top`,
			onUpdate(e) {
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				console.log(e.progress);
				chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll / 1.9) * e.progress}px, 0)`;
			},
			onEnter: () => {
				console.log("enter уу");
			},
			pin: trolleyWrapper, // pin: chartBlockEl,
		});
		functionSTArr.push(sectionST);

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const block_2 = textBlocksArr[1];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		// const chart_1 =
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_1_pointer}"]`),
		};
		chart_1.mainCircle = chart_1.chartWrapper.querySelector(".chart-circle");
		chart_1.bgCircle = chart_1.mainCircle.querySelector(".chart-circle__bg");
		chart_1.smallCircle = chart_1.mainCircle.querySelector(".chart-circle__fill");
		chart_1.text = chart_1.smallCircle.querySelector(".chart-circle__graph-text");
		chart_1.smallCircleDefaultScale = Math.sqrt(parseFloat(chart_1.smallCircle.getAttribute("data-circle-scale"), 10));
		chart_1.legend = chartBlockEl.querySelector(`.chart-legend_caption-col[data-chart="${chart_1_pointer}"]`);
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');

		const textST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 90,
			invalidateOnRefresh: true,
			markers: false, // id: 'p-1',
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${block_1.clientHeight + gapFromStartOfTheBlock / 2} center` : `top-=${pinOffset - 300} top`,
			onEnter: () => {
				console.log("enter 1");
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: () => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
			},
			onLeave: () => {
				block_1.classList.remove("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.add("charts-row--hidden");
			}, // destructed element : { progress, direction, isActive }
			onLeaveBack: () => {
				block_1.classList.add("js-scrollanimation-text--active");
			},
			onUpdate(e) {
				paragraph_1_animation(e.progress);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(textST);

		// Animation for the second paragraph
		const chart_2_pointer = block_2.getAttribute("data-to-chart");
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_2_pointer}"]`), columns: [],
		};
		const chart2Columns = chart_2.chartWrapper.querySelectorAll(".charts-col");
		chart2Columns.forEach((chart2Col, index) => {
			chart_2.columns.push({
				index,
				column: chart2Col,
				textValueEl: chart2Col.querySelector(".chart-value"),
				textCaptionEl: chart2Col.querySelector(".chart-caption"),
				mainCircle: chart2Col.querySelector(".chart-circle"),
				bgCircle: chart2Col.querySelector(".chart-circle__bg"),
				smallCircle: chart2Col.querySelector(".chart-circle__fill"),
				smallCircleDefaultScale: Math.sqrt(parseFloat(chart2Col
					.querySelector(".chart-circle__fill")
					.getAttribute("data-circle-scale"), 10)),
			});
		});
		chart_2.legend = chartBlockEl.querySelector(`.chart-legend_caption-col[data-chart="${chart_2_pointer}"]`);
		chart_2.legend.style.opacity = `0`;
		chart_2.legend.style.transform = `translate3d(0, 30%, 0)`;
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');
		// Set initial scale 0 to bg cirlces in animation
		// chart_2.columns.forEach((column) => {
		// 	// Scale bg cirlces
		// 	column.bgCircle.style.transform = `scale3d(0, 0, 1)`;
		// });

		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 89,

			// trigger: block_2,
			invalidateOnRefresh: true,
			markers: false, // id: 'p-2',
			start: !helpers.isMobile() ? `top+=${block_2.offsetTop + gapFromStartOfTheBlock / 2} center` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock} center` : `top-=${pinOffset - 450} top`,
			onEnter: () => {
				console.log("enter 2");
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			}, // { progress, direction, isActive }
			onLeave: () => {
				// block_2.classList.remove('js-scrollanimation-text--active');
			},
			onLeaveBack: () => {
				block_2.classList.remove("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.add("charts-row--hidden");
				// chart_2.chartWrapper.classList.remove('charts-row--hidden');
			},
			onUpdate(e) {
				paragraph_2_animation(e.progress);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartText2.offsetHeight + 30);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		function paragraph_1_animation(progress) {
			// Quickly hide all other elements of the cirlce
			// Clamp value between 0 and 1
			const fastOpacity = clamp(1 - progress * 7, 0, 1); // Will return: 0
			// const fastOpacity = Math.min(Math.max((1 - progress * 7), 0), 1);

			// chart_1.bgCircle.style.opacity = fastOpacity;
			// chart_1.text.style.opacity = fastOpacity;

			// Move legend
			chart_1.legend.style.opacity = String(1 - progress);

			// // Lift cirlce up on half of the height
			// const circleDelta = (-1 * progress * chart_1.smallCircle.clientHeight) / 2;
			//
			// // Start scaling down the object when progress is higher than 80%
			// // 		p.s. we are using math formulas to avoid using if operator in order to gain performance
			// const circleScale = chart_1.smallCircleDefaultScale - 0.5 * Math.abs(Math.max(progress - 0.8, 0));
			// chart_1.smallCircle.style.transform = `scale3d(${circleScale}, ${circleScale}, 1) translate3d(0, 0, 0)`;
		}

		// Second text block related animation
		function paragraph_2_animation(progress) {
			const number = (1 - progress) * 30;
			// const columnsArrLength = chart_2.columns.length;

			// Move legend
			chart_2.legend.style.opacity = String(progress);

			if (0 > number) {
				chart_2.legend.style.transform = `translate3d(0, ${number}%, 0)`;
			}

			// chart_2.columns.forEach((column) => {
			// 	const captionsOpacity = clamp(progress * (columnsArrLength - column.index), 0, 1);
			// 	const particleCaptionsOpacity = clamp(progress * 0.2 * (columnsArrLength - column.index), 0, 0.5);
			//
			// 	column.textValueEl.style.opacity = captionsOpacity;
			// 	column.textCaptionEl.style.opacity = captionsOpacity;
			//
			// 	// Move circle on a delta
			// 	const deltaDistance = Math.round(chart_2.chartWrapper.clientWidth / 2) - column.column.offsetLeft - column.mainCircle.clientWidth / 2;
			// 	const deltaCircle = deltaDistance * (1 - progress);
			// 	column.mainCircle.style.transform = `translate3d(${deltaCircle}px, 0, 0)`;
			//
			// 	// Scale bg cirlces
			// 	column.bgCircle.style.transform = `scale3d(${progress}, ${progress}, 1)`;
			// });
		}

		return functionSTArr;
	} else {
		return [];
	}
}

// Init animation for "amount of nurses" chart
function initNursesAnimation() {
	const chartBlockEl = document.querySelector(".js-nurses-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley block
		const trolleyWrapper = chartBlockEl.closest(".trolley");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");

		// Trigger distance from start of the block
		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock;
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			refreshPriority: 88,
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			invalidateOnRefresh: true,
			id: "nurses", // markers: false,
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll + 60} center` : `top-=${pinOffset - 450} top`,
			onUpdate(e) {
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				console.log(e.progress);
				chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll / 1.6) * e.progress}px, 0)`;
			},
		});
		functionSTArr.push(sectionST);

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_1_pointer}"]`),
		};

		let stepParam = helpers.isMobile ? 100 : 0;

		const text1ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 87,
			invalidateOnRefresh: true, // markers: false,
			// id: 'p-1',
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${block_1.clientHeight + gapFromStartOfTheBlock / 4} center` : `top-=${pinOffset - 300} top`,
			onEnter: () => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: () => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
			},
			onLeave: () => {
				block_1.classList.remove("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.add("charts-row--hidden");
			}, // destructed element : { progress, direction, isActive }
			onLeaveBack: () => {
				block_1.classList.add("js-scrollanimation-text--active");
			},
			onUpdate(e) {
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text1ST);

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		const chart_2_pointer = block_2.getAttribute("data-to-chart");
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_2_pointer}"]`), columns: [],
		};
		const chart2Columns = chart_2.chartWrapper.querySelectorAll(".charts-col");
		chart2Columns.forEach((chart2Col, index) => {
			chart_2.columns.push({
				index,
				column: chart2Col,
				mainCircle: chart2Col.querySelector(".chart-circle"),
				bgCircle: chart2Col.querySelector(".chart-circle__bg"),
				smallCircle: chart2Col.querySelector(".chart-circle__fill"),
				smallCircleDefaultScale: Math.sqrt(parseFloat(chart2Col
					.querySelector(".chart-circle__fill")
					.getAttribute("data-circle-scale"), 10)),
			});
		});
		chart_2.legend = chartBlockEl.querySelector(`.chart-legend_caption-col[data-chart="${chart_2_pointer}"]`);
		chart_2.legend.style.opacity = `0`;
		chart_2.legend.style.transform = `translate3d(0, 30%, 0)`;

		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 86,
			invalidateOnRefresh: true, // markers: false,
			// id: 'p-2',
			start: !helpers.isMobile() ? `top+=${block_2.offsetTop + gapFromStartOfTheBlock / 4} center` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock} center` : `top-=${pinOffset - 450} top`,

			onEnter: () => {
				console.log("enter 3");
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			}, // { progress, direction, isActive }
			// onLeave: () => {
			// 	block_2.classList.remove('js-scrollanimation-text--active');
			// },
			onLeaveBack: () => {
				block_2.classList.remove("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.add("charts-row--hidden");
			},
			onUpdate(e) {
				paragraph_2_animation(e.progress);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartText2.offsetHeight + 30);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		// function paragraph_1_animation(progress) {
		// }

		// Second text block related animation
		function paragraph_2_animation(progress) {
			// Move legend
			let num = (1 - progress) * 30;
			chart_2.legend.style.opacity = String(progress);

			if (0 > num) {
				chart_2.legend.style.transform = `translate3d(0, ${num}%, 0)`;
			}

			// Scale circles up
			// chart_2.columns.forEach((column) => {
			// 	//  Scale up the small circle according to the progress
			// 	const circleScale = column.smallCircleDefaultScale * progress;
			// 	column.smallCircle.style.transform = `scale3d(${circleScale}, ${circleScale}, 1)`;
			// });
		}

		return functionSTArr;
	} else {
		return [];
	}
}

function initCapableAnimation() {
	const chartBlockEl = document.querySelector(".js-capable-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley block
		const trolleyWrapper = chartBlockEl.closest(".trolley");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");

		// Trigger distance from start of the block
		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48;
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			refreshPriority: 81,
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			invalidateOnRefresh: true,
			// id: "capable",
			// markers: true,
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll + 60} center` : `top-=${pinOffset - 450} top`,
			onUpdate(e) {
				console.log(`${(distanceToScroll * 0.7) * e.progress}`);
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll * 0.7) * e.progress}px, 0)`;
			},
		});
		functionSTArr.push(sectionST);

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		// const chart_1 =
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_1_pointer}"]`),
		};
		chart_1.mainCircle = chart_1.chartWrapper.querySelector(".chart-circle");
		chart_1.bgCircle = chart_1.mainCircle.querySelector(".chart-circle__bg");
		chart_1.smallCircle = chart_1.mainCircle.querySelector(".chart-circle__fill");
		chart_1.text = chart_1.smallCircle.querySelector(".chart-circle__graph-text");
		chart_1.smallCircleDefaultScale = Math.sqrt(parseFloat(chart_1.smallCircle.getAttribute("data-circle-scale"), 10));
		chart_1.textDefaultScale = 1 / chart_1.smallCircleDefaultScale;
		chart_1.legend = chartBlockEl.querySelector(`.chart-legend_caption[data-chart="${chart_1_pointer}"]`);

		let stepParam = helpers.isMobile ? 200 : 0;

		const text1ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 80,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${block_1.clientHeight - gapFromStartOfTheBlock} center` : `top-=${pinOffset - 300} top`,
			// markers: true,
			// id: "pt-1-1",
			onEnter: ({progress}) => {
				console.log("enter 4");
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: ({progress}) => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
			},
			onLeave: ({progress, direction, isActive}) => {
				block_1.classList.remove("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.add("charts-row--hidden");
			},
			onUpdate(e) {
				paragraph_1_animation(e.progress);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text1ST);

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		const chart_2_pointer = block_2.getAttribute("data-to-chart");
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_2_pointer}"]`),
		};
		chart_2.mainCircle = chart_2.chartWrapper.querySelector(".chart-circle");
		chart_2.bgCircle = chart_2.mainCircle.querySelector(".chart-circle__bg");
		chart_2.smallCircle = chart_2.mainCircle.querySelector(".chart-circle__fill");
		chart_2.textEl = chart_2.smallCircle.querySelector(".chart-circle__graph-text");
		chart_2.smallCircleDefaultScale = Math.sqrt(parseFloat(chart_2.smallCircle.getAttribute("data-circle-scale"), 10));
		chart_2.textDefaultScale = 1 / chart_2.smallCircleDefaultScale;

		// chart_2.smallCircle.style.transform = `scale3d(0, 0, 1)`;
		// chart_2.textEl.style.transform = `transform: translate(-50%, -50%) scale3d(0, 0, 1)`;

		chart_2.legend = chartBlockEl.querySelector(`.chart-legend_caption[data-chart="${chart_2_pointer}"]`);
		chart_2.legend.style.opacity = `0`;
		chart_2.legend.style.transform = `translate3d(0, 70%, 0)`;

		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 79,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top+=${block_2.offsetTop - gapFromStartOfTheBlock} center` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock} center` : `top-=${pinOffset - 450} top`,
			// markers: true,
			// id: "pt-2-1",

			onEnter: ({progress}) => {
				console.log("enter 5");
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: ({progress}) => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			}, // onLeave: ({ progress, direction, isActive }) => {
			// 	block_2.classList.remove('js-scrollanimation-text--active');
			// 	// chart_2.chartWrapper.classList.add('charts-row--hidden');
			// },
			onLeaveBack: ({progress, direction, isActive}) => {
				chart_2.chartWrapper.classList.add("charts-row--hidden");
			},
			onUpdate(e) {
				paragraph_2_animation(e.progress * 1.4);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartText2.offsetHeight + 30);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		function paragraph_1_animation(progress) {
			// // Quickly hide all other elements of the cirlce
			// // Clamp value between 0 and 1
			// const fastOpacity = clamp(1 - progress * 7, 0, 1); // Will return: 0
			// // const fastOpacity = Math.min(Math.max((1 - progress * 7), 0), 1);
			//
			// chart_1.bgCircle.style.opacity = fastOpacity;
			// chart_1.text.style.opacity = fastOpacity;

			// Move legend
			chart_1.legend.style.opacity = String(1 - progress);

			// // Lift cirlce up on half of the height
			// const circleDelta = (-1 * progress * chart_1.smallCircle.clientHeight) / 2;
			//
			// // Start scaling down the object when progress is higher than 80%
			// // 		p.s. we are using math formulas to avoid using if operator in order to gain performance
			// const circleScale = chart_1.smallCircleDefaultScale - 0.5 * Math.abs(Math.max(progress - 0.8, 0));
			// chart_1.smallCircle.style.transform = `scale3d(${circleScale}, ${circleScale}, 1) translate3d(0, ${circleDelta}px, 0)`;
		}

		// Second text block related animation
		function paragraph_2_animation(progress) {
			let number = (1 - (progress)) * 30;
			// Quickly hide all other elements of the cirlce
			// Clamp value between 0 and 1
			// const fastOpacity = clamp(1 - progress * 7, 0, 1); // Will return: 0
			//
			// chart_1.bgCircle.style.opacity = fastOpacity;
			// chart_1.text.style.opacity = fastOpacity;

			// Move legend
			chart_2.legend.style.opacity = String(progress);

			if (number === 0 || number > 0) {
				chart_2.legend.style.transform = `translate3d(0, ${number}%, 0)`;
			}

			// const circleScaleCoeff = chart_2.smallCircleDefaultScale * progress;
			// const textScaleCoeff = 1 / Math.min(0.1, progress);

			// chart_2.smallCircle.style.transform = `scale3d(${circleScaleCoeff}, ${circleScaleCoeff}, 1)`;
			// chart_2.textEl.style.transform = `transform: translate(-50%, -50%) scale3d(${textScaleCoeff}, ${textScaleCoeff}, 1);`;
		}

		return functionSTArr;
	} else {
		return [];
	}
}

function triggerTooltip(chart, index) {
	const tooltip = chart.tooltip;
	if (tooltip.getActiveElements().length > 0) {
		tooltip.setActiveElements([], {x: 0, y: 0});
	} else {
		const chartArea = chart.chartArea;
		tooltip.setActiveElements([{
			datasetIndex: 0, index: index,
		},], {
			x: (chartArea.left + chartArea.right) / 2, y: (chartArea.top + chartArea.bottom) / 2,
		});
	}

	chart.update();
}

function initChartJS() {
	/**
	 *  Chart code -->
	 **/
		//
		// Init chart.js graph
	const chartJs = document.querySelector('.js-telegraph-svg');
	const chartContainer = chartJs.querySelector('.graphic-chart');
	const chart = chartJs.querySelector('svg');

	if (!chart) {
		return;
	}

	const popup = chartJs.querySelector('.chart-course__popup');
	const dot = chart.querySelectorAll('circle[data-dot]');
	const point = chartJs.querySelector('.chart-course__dot');
	const dataArr = ['4, 1865 г.', '90, 1866 г.', '53, 1867 г.', '49, 1868 г.', '69, 1869 г.', '96, 1870 г.', '76, 1871 г.', '75, 1872 г.', '92, 1873 г.', '63, 1874 г.', '70, 1875 г.', '44, 1876 г.', '49, 1877 г.', '49, 1878 г.', '32, 1879 г.', '21, 1880 г.', '26, 1881 г.', '62, 1882 г.', '58, 1883 г.', '59, 1884 г.', '43, 1885 г.', '26, 1886 г.', '34, 1887 г.', '28, 1888 г.', '42, 1889 г.', '27, 1890 г.', '52, 1891 г.', '73, 1892 г.'];


	dot.forEach((item) => {
		item.addEventListener('mouseenter', (event) => {
			let dataPoint = event.currentTarget.getAttribute('data-dot');
			let rect = event.currentTarget.getBBox();
			let coef = chartContainer.offsetWidth / chart.getBBox().width;

			if (!dataPoint) {
				return;
			}

			popup.innerHTML = dataArr[dataPoint - 1];

			popup.style.left = `${(rect.x + 7) * coef - popup.offsetWidth / 2}px`;
			popup.style.top = `${(rect.y + 15) * coef}px`;

			point.style.left = `${(rect.x + 5) * coef}px`;
			point.style.top = `${(rect.y + 5) * coef}px`;

			if (point.classList.contains('is-active')) {
				point.classList.remove('is-active');
				popup.classList.remove('is-active');
			}

			popup.classList.add('is-active');
			point.classList.add('is-active');
		});
	});

	chart.addEventListener('mouseleave', () => {
		if (point.classList.contains('is-active')) {
			point.classList.remove('is-active');
			popup.classList.remove('is-active');
		}
	});


	// const chartCanvas = document.getElementById("telegraph-chart");
	// if (chartCanvas) {
	// 	const ctx = chartCanvas.getContext("2d");
	//
	// 	const setLabels = (start, limit) => {
	// 		let resArr = [];
	//
	// 		for (let i = start; i < limit + 1; i++) {
	// 			resArr.push(i);
	// 		}
	//
	// 		return resArr;
	// 	};
	// 	const labelsArr = setLabels(1864, 1893);
	//
	// 	// const dataArr1 = [3, 95, 52, 50, 74, 97, 76, 75, 96, 70, 73, 47, 50, 50, 30, 23, 25, 60, 57, 59, 25, 30, 26, 40, 26, 51, 75];
	// 	const dataArr = [
	// 		4, 90, 53, 49, 69, 96, 76, 75, 92, 63, 70, 44, 49, 49, 32, 21, 26,
	// 		62, 58, 59, 43, 26, 34, 28, 42, 27, 52, 73,
	// 	];
	//
	// 	const purpleColor = "rgb(169, 70, 255)";
	// 	const data = {
	// 		labels: labelsArr,
	// 		datasets: [
	// 			{
	// 				fill: false,
	// 				borderColor: purpleColor,
	// 				data: dataArr,
	// 				tension: 0,
	// 				borderWidth: 2,
	// 				fontColor: purpleColor,
	// 			},
	// 		],
	// 	};
	//
	// 	const customizeGraph = {
	// 		id: "customizeGraph",
	// 		beforeDatasetDraw(chart, args, pluginOptions) {
	// 			const {
	// 				ctx,
	// 				data,
	// 				scales: { x, y },
	// 			} = chart;
	//
	// 			// Put label higher (align on bottom of the label box which puts it higher)
	// 			y._labelItems.forEach((item) => {
	// 				// item.textAlign = 'left';
	// 				item.textBaseline = "bottom";
	// 			});
	//
	// 			// Correct lines width
	// 			y._gridLineItems.forEach((gridLine, index) => {
	// 				gridLine.color = "#E5E0E4";
	// 				if (index % 2 == 0) {
	// 					// Then it's an even number
	// 					gridLine.color = "rgba(119, 105, 128, 0.8)";
	// 				}
	// 				if (index == 0) {
	// 					// Then it's an even number
	// 					gridLine.width = 1.5;
	// 					gridLine.color = "#5E5C5C";
	// 				}
	// 			});
	// 		},
	// 	};
	//
	// 	// Annotation line
	// 	const annotationLine = {
	// 		id: "annotationLine", // NOTE!
	// 		// Keep in mind that in canvas
	// 		// 	y axes starts at the top and directed down!
	// 		// 		So y=0 is at the top and positive direction is down the page
	// 		beforeDraw: (chart, index) => {
	// 			if (
	// 				chart.tooltip._active &&
	// 				chart.tooltip._active.length &&
	// 				telegraphChart.isShowAnnotationLine
	// 			) {
	// 				const ctx = chart.ctx;
	// 				ctx.save();
	//
	// 				// Grab active point
	// 				const activePoint = chart.tooltip._active[0];
	// 				const chartTop = chart.chartArea.top;
	// 				const chartHeight = chart.chartArea.height;
	//
	// 				ctx.beginPath();
	// 				// ctx.setLineDash([5, 7]);
	// 				ctx.moveTo(activePoint.element.x, chartHeight + chartTop);
	// 				ctx.lineTo(activePoint.element.x, activePoint.element.y);
	// 				ctx.lineWidth = 1;
	// 				ctx.strokeStyle = "#DDBDF9";
	// 				ctx.stroke();
	// 				ctx.restore();
	// 			}
	// 		},
	// 	};
	//
	// 	// const customTooltip = tooltip
	// 	const customLabel = (tooltip, data) => {
	// 		const label = tooltip.label;
	// 		const value = parseFloat(tooltip.formattedValue).toLocaleString(
	// 			"en"
	// 		);
	// 		return `${value}, ${label} г.`;
	// 	};
	//
	// 	const config = {
	// 		type: "line",
	// 		data,
	// 		options: {
	// 			maintainAspectRatio: true,
	// 			plugins: {
	// 				tooltip: {
	// 					enabled: true,
	// 					backgroundColor: "rgba(255, 255, 255, 1)",
	// 					cornerRadius: 0,
	// 					displayColors: false,
	// 					usePointStyle: true,
	// 					padding: 8,
	// 					xAlign: "center",
	// 					yAlign: "top",
	// 					caretPadding: 20,
	// 					caretSize: 0,
	// 					callbacks: {
	// 						labelTextColor: function (context) {
	// 							return "rgba(0, 0, 0, 1)";
	// 						},
	// 						label: customLabel,
	// 						title: () => {
	// 							return "";
	// 						},
	// 					},
	// 				},
	// 			},
	// 			elements: {
	// 				point: {
	// 					radius: 2,
	// 					hoverRadius: 7,
	// 					borderWidth: 0,
	// 					backgroundColor: purpleColor,
	// 					borderColor: "white",
	// 				},
	// 			},
	// 			legend: {
	// 				labels: {
	// 					color: "rgba(0, 0, 0, 0)",
	// 				},
	// 			},
	// 			scales: {
	// 				x: {
	// 					// beginAtZero: false,
	// 					min: data.labels[0],
	// 					max: data.labels[data.labels.length - 1],
	// 					ticks: {
	// 						color: purpleColor,
	// 						stepSize: 1,
	// 						maxRotation: 0,
	// 						callback: function (value, index, ticks) {
	// 							if (
	// 								index === 0 ||
	// 								index === data.labels.length - 2
	// 							) {
	// 								return data.labels[index];
	// 							}
	// 						},
	// 					},
	// 					grid: {
	// 						display: false,
	// 					},
	// 				},
	// 				y: {
	// 					min: 0,
	// 					max: 110,
	// 					grid: {
	// 						drawBorder: false,
	// 					},
	// 					ticks: {
	// 						// forces step size to be 25 units
	// 						stepSize: 25, // maxTicksLimit: 3,
	// 						// labelOffset: -10,
	// 						// Include a unit sign in the ticks
	// 						callback: function (value, index, ticks) {
	// 							let additionalString = "";
	// 							if (value === 100) {
	// 								additionalString = " чел.";
	// 							}
	// 							// Don't show the ticks
	// 							if (value == 25 || value == 75) {
	// 								return ``;
	// 							}
	// 							if (value == 110) {
	// 								return undefined;
	// 							}
	// 							return `${value}${additionalString}`;
	// 						},
	// 					},
	// 				},
	// 			},
	// 		},
	// 		plugins: [customizeGraph, annotationLine],
	// 	};
	//
	// 	const myChart = new Chart(ctx, config);
	//
	// 	return myChart;
	// }
}

function initChartJSAnimation() {
	const chartBlockEl = document.querySelector(".js-telegraph-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley wrapper
		const trolleyParentEl = chartBlockEl.closest(".trolley-big");

		// Trolley block
		const trolleyWrapper = chartBlockEl.closest(".trolley");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");

		// Trigger distance from start of the block
		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		let distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock;
		if (helpers.isMobile()) {
			distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48;
		}
		let chartText1 = chartBlockEl.querySelector('.js-scrollanimation-text[data-to-chart="1"]');
		let chartText2 = chartBlockEl.querySelector('.js-scrollanimation-text[data-to-chart="2"]');
		let chartText3 = chartBlockEl.querySelector('.js-scrollanimation-text[data-to-chart="3"]');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			refreshPriority: 78,
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			invalidateOnRefresh: true,
			id: "telegraph",
			markers: false,
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll} center` : `top-=${pinOffset - 900} top`,
			onUpdate(e) {
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				if (helpers.isMobile()) {
					chartTextBlockEl.style.transform = `translate3d(0, -${distanceToScroll * e.progress}px, 0)`;
				} else {
					chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll / 1.8) * e.progress}px, 0)`;
				}
			},
			onEnter: () => {
				trolleyParentEl.classList.add("trolley-custom");
			},
			onEnterBack: () => {
				trolleyParentEl.classList.add("trolley-custom");
			},
		});
		functionSTArr.push(sectionST);
		let stepParam = helpers.isMobile ? 200 : 0;
		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		// const chart_1_pointer = block_1.getAttribute('data-to-chart');

		const text1ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 77,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${(block_1.clientHeight - gapFromStartOfTheBlock)} top` : `top-=${pinOffset - 300} top`,
			// markers: false,
			onEnter: ({progress}) => {
				console.log("enter 6");
				block_1.classList.add("js-scrollanimation-text--active");
				chartEl.setAttribute('data-step', '1');
			},
			onEnterBack: ({progress}) => {
				block_1.classList.add("js-scrollanimation-text--active");
				chartEl.setAttribute('data-step', '1');
			},
			onLeave: ({progress, direction, isActive}) => {
				block_1.classList.remove("js-scrollanimation-text--active");
			},
			onUpdate(e) {
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text1ST);

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		// const chart_2_pointer = block_2.getAttribute('data-to-chart');

		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 76,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top+=${(block_2.offsetTop - gapFromStartOfTheBlock) + 100} center` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${(block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock)} top` : `top-=${pinOffset - 600} top`,
			// id: 'p-2',
			onEnter: ({progress}) => {
				console.log("enter 7");
				block_2.classList.add("js-scrollanimation-text--active");
				telegraphChart.isShowAnnotationLine = true;
				// triggerTooltip(telegraphChart.chart, 7);
				chartEl.setAttribute('data-step', '2');
			},
			onEnterBack: ({progress}) => {
				block_2.classList.add("js-scrollanimation-text--active");
				// telegraphChart.isShowAnnotationLine = true;
				// triggerTooltip(telegraphChart.chart, 7);
				chartEl.setAttribute('data-step', '2');
			},
			onLeave: ({progress, direction, isActive}) => {
				block_2.classList.remove("js-scrollanimation-text--active");
				// telegraphChart.isShowAnnotationLine = false;
				// triggerTooltip(telegraphChart.chart, 7);
			},
			onLeaveBack: ({progress, direction, isActive}) => {
				block_2.classList.remove("js-scrollanimation-text--active");
				// telegraphChart.isShowAnnotationLine = false;
				// triggerTooltip(telegraphChart.chart, 7);
			},
			onUpdate(e) {
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText2.offsetHeight);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		// Animation for the 3-rd paragraph
		const block_3 = textBlocksArr[2];

		const text3ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 75,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top+=${(block_3.offsetTop - gapFromStartOfTheBlock * 2)} top` : `top-=${pinOffset - 600} top`,
			end: !helpers.isMobile() ? `top+=${block_3.offsetTop + block_3.clientHeight - gapFromStartOfTheBlock} top` : `top-=${pinOffset - 900} top`,
			// id: 'p-3',
			onEnter: ({progress}) => {
				block_3.classList.add("js-scrollanimation-text--active");
				chartEl.setAttribute('data-step', '3');
			},
			onEnterBack: ({progress}) => {
				block_3.classList.add("js-scrollanimation-text--active");
				chartEl.setAttribute('data-step', '3');
			}, // onLeave: ({ progress, direction, isActive }) => {
			// 	block_3.classList.remove('js-scrollanimation-text--active');
			// },
			onLeaveBack: ({progress, direction, isActive}) => {
				block_3.classList.remove("js-scrollanimation-text--active");
			}, // onLeaveBack: ({ progress, direction, isActive }) => {
			// },
			// onUpdate(e) {
			// 	paragraph_2_animation(e.progress);
			// },
			onUpdate(e) {
				if (helpers.isMobile()) {
					const progress = -e.progress * (window.innerHeight);

					chartText3.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text3ST);

		return functionSTArr;
	} else {
		return [];
	}
}

/**
 *  ACTIVATE CHARTS ANIMATION <-
 **/
function initTelegraphAnimation() {
	let functionSTArr = [];

	// Chart JS
	telegraphChart.chart = initChartJS();

	// Chart JS animation
	functionSTArr = initChartJSAnimation();
	return functionSTArr;
}

function initFactoryAnimation() {
	const chartBlockEl = document.querySelector(".js-factory-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley wrapper
		const trolleyWrapper = chartBlockEl.closest(".trolley-big");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");

		// Trigger distance from start of the block
		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48;
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			refreshPriority: 74,
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			invalidateOnRefresh: true,
			// id: "1-factory-1",
			// markers: true,
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll} center` : `top-=${pinOffset - 450} top`,
			onEnter: () => {
			},
			onEnterBack: () => {
			},
			onLeave: () => {
				trolleyWrapper.classList.remove("trolley-custom");
			},
			onLeavBack: () => {
				trolleyWrapper.classList.remove("trolley-custom");
			},
			onToggle: ({isActive}) => {
				// if (isActive === true) {
				// 	// outter trolley-big
				// 	trolleyWrapper.classList.add('trolley-custom');
				// } else {
				// 	trolleyWrapper.classList.remove('trolley-custom');
				// }
			},
			onUpdate(e) {
				console.log(`${(distanceToScroll * 0.7) * e.progress}`);
				console.log(`${distanceToScroll * e.progress}px, 0)`);
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				chartTextBlockEl.style.transform = `translate3d(0, -${distanceToScroll * e.progress}px, 0)`;

			},
		});
		functionSTArr.push(sectionST);

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		// const chart_1 =
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_1_pointer}"]`),
		};
		chart_1.mainCircle = chart_1.chartWrapper.querySelector(".chart-circle");
		chart_1.bgCircle = chart_1.mainCircle.querySelector(".chart-circle__bg");
		chart_1.smallCircle = chart_1.mainCircle.querySelector(".chart-circle__fill");
		chart_1.text = chart_1.smallCircle.querySelector(".chart-circle__graph-text");
		chart_1.smallCircleDefaultScale = Math.sqrt(parseFloat(chart_1.smallCircle.getAttribute("data-circle-scale"), 10));

		const text1ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 73,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top center` : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${block_1.clientHeight + gapFromStartOfTheBlock} bottom` : `top-=${pinOffset - 300} top`,
			// markers: true,
			// id: "pt-1-2",
			onEnter: ({progress}) => {
				console.log("enter 8");
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: ({progress}) => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
			},
			onLeave: ({progress, direction, isActive}) => {
				block_1.classList.remove("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.add("charts-row--hidden");
			},
			onUpdate(e) {
				// paragraph_1_animation(e.progress);
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text1ST);

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		const chart_2_pointer = block_2.getAttribute("data-to-chart");
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_2_pointer}"]`), columns: [],
		};
		const chart2Columns = chart_2.chartWrapper.querySelectorAll(".charts-col");
		chart2Columns.forEach((chart2Col, index) => {
			chart_2.columns.push({
				index,
				column: chart2Col,
				textValueEl: chart2Col.querySelector(".chart-value"),
				textCaptionEl: chart2Col.querySelector(".chart-caption"),
				mainCircle: chart2Col.querySelector(".chart-circle"),
				bgCircle: chart2Col.querySelector(".chart-circle__bg"),
				smallCircle: chart2Col.querySelector(".chart-circle__fill"),
				smallCircleDefaultScale: Math.sqrt(parseFloat(chart2Col
					.querySelector(".chart-circle__fill")
					.getAttribute("data-circle-scale"), 10)),
			});
		});

		// Set initial scale 0 to bg cirlces in animation
		// chart_2.columns.forEach((column) => {
		// 	// Scale bg cirlces
		// 	column.bgCircle.style.transform = `scale3d(0, 0, 1)`;
		// });

		// New
		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 72,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top+=${block_2.offsetTop + gapFromStartOfTheBlock} bottom` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock} center` : `top-=${pinOffset - 450} top`,
			// markers: true,
			// id: "pt-2-2",
			onEnter: () => {
				console.log("enter 10");
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			}, // { progress, direction, isActive }
			// onLeave: () => {
			// 	block_2.classList.remove('js-scrollanimation-text--active');
			// },
			onLeaveBack: () => {
				block_2.classList.remove("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.add("charts-row--hidden");
				// chart_2.chartWrapper.classList.remove('charts-row--hidden');
			},
			onUpdate(e) {
				// paragraph_2_animation(e.progress);
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartText2.offsetHeight + 30);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		// New

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		function paragraph_1_animation(progress) {
			// Quickly hide all other elements of the cirlce
			// Clamp value between 0 and 1
			const fastOpacity = clamp(1 - progress * 7, 0, 1); // Will return: 0
			// const fastOpacity = Math.min(Math.max((1 - progress * 7), 0), 1);

			chart_1.bgCircle.style.opacity = fastOpacity;
			chart_1.text.style.opacity = fastOpacity;

			// Lift cirlce up on half of the height
			const circleDelta = (-1 * progress * chart_1.smallCircle.clientHeight) / 2;

			// Start scaling down the object when progress is higher than 80%
			// 		p.s. we are using math formulas to avoid using if operator in order to gain performance
			const circleScale = chart_1.smallCircleDefaultScale - 0.5 * Math.abs(Math.max(progress - 0.8, 0));
			chart_1.smallCircle.style.transform = `scale3d(${circleScale}, ${circleScale}, 1) translate3d(0, ${circleDelta}px, 0)`;
		}

		// Second text block related animation
		function paragraph_2_animation(progress) {
			const columnsArrLength = chart_2.columns.length;
			chart_2.columns.forEach((column) => {
				const captionsOpacity = clamp(progress * (columnsArrLength - column.index), 0, 1);
				const fastCaptionsOpacity = clamp(progress * (columnsArrLength - column.index), 0, 0.5);

				column.textValueEl.style.opacity = captionsOpacity;
				column.textCaptionEl.style.opacity = fastCaptionsOpacity;

				// Move circle on a delta
				const deltaDistance = Math.round(chart_2.chartWrapper.clientWidth / 2) - column.column.offsetLeft - column.mainCircle.clientWidth / 2;
				const deltaCircle = deltaDistance * (1 - progress);
				column.mainCircle.style.transform = `translate3d(${deltaCircle}px, 0, 0)`;

				// Scale bg cirlces
				column.bgCircle.style.transform = `scale3d(${progress}, ${progress}, 1)`;
			});
		}

		return functionSTArr;
	} else {
		return [];
	}
}

// Universities animation js-universities-animation
function initUniversitiesAnimation() {
	const chartBlockEl = document.querySelector(".js-universities-animation");
	if (chartBlockEl) {
		let functionSTArr = [];
		// Init svg map
		universitiesAnimation.init(chartBlockEl);

		// Trolley wrapper
		const trolleyParentEl = chartBlockEl.closest(".trolley-big");

		// Trolley block
		const trolleyWrapper = chartBlockEl.closest(".trolley");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");

		// Trigger distance from start of the block
		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48;
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			refreshPriority: 71,
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			invalidateOnRefresh: true,
			id: "universities",
			markers: false,
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll} center` : `top-=${pinOffset - 600} top`,
			onUpdate(e) {
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				chartTextBlockEl.style.transform = `translate3d(0, -${distanceToScroll * e.progress}px, 0)`;
			},
			onEnter: () => {
				trolleyParentEl.classList.add("trolley-custom");
			},
			onEnterBack: () => {
				trolleyParentEl.classList.add("trolley-custom");
			},
		});
		functionSTArr.push(sectionST);

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_1_pointer}"]`),
		};
		// const chart_1_pointer = block_1.getAttribute('data-to-chart');
		let chartContainer = document.querySelector(".svg-chart");

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		// const chart_2_pointer = block_2.getAttribute('data-to-chart');
		const chart_2_pointer = block_2.getAttribute("data-to-chart");

		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_2_pointer}"]`),
		};

		const text1ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 70,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top center` : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${block_1.clientHeight + gapFromStartOfTheBlock} bottom` : `top-=${pinOffset - 300} top`,
			// markers: false,
			onEnter: ({progress}) => {
				console.log("enter 11");
				// chartText1.style.bottom = 103 + "%";
				chartContainer.setAttribute("data-stage", "1");
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");

				if (helpers.isMobile()) {
					block_2.classList.remove("js-scrollanimation-text--active");
					// chart_2.chartWrapper.classList.add('charts-row--hidden');
				}
			},
			onEnterBack: ({progress}) => {
				chartContainer.setAttribute("data-stage", "1");
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
				// chartText1.style.bottom = 103 + "%";

				if (helpers.isMobile()) {
					block_2.classList.remove("js-scrollanimation-text--active");
					// chart_2.chartWrapper.classList.add('charts-row--hidden');
				}
			},
			onLeave: ({progress, direction, isActive}) => {
				block_1.classList.remove("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.add("charts-row--hidden");
				// chartText1.style.bottom = -50 + "%";
			},
			onUpdate(e) {
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text1ST);

		if (helpers.isMobile()) {
			chart_2.chartWrapper.classList.add("charts-row--hidden");
		}

		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 69,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top+=${block_2.offsetTop + gapFromStartOfTheBlock} bottom` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock} center` : `top-=${pinOffset - 600} top`,
			markers: false, // id: 'p-2',
			onEnter: () => {
				console.log("enter 12");
				// chartText2.style.bottom = 103 + "%";
				block_2.classList.add("js-scrollanimation-text--active");
				chartContainer.setAttribute("data-stage", "2");
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");

				if (helpers.isMobile()) {
					block_1.classList.remove("js-scrollanimation-text--active");
					// chart_1.chartWrapper.classList.add('charts-row--hidden');
				}
			},
			onEnterBack: () => {
				block_2.classList.remove("js-scrollanimation-text--active");
				chartContainer.setAttribute("data-stage", "2");
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
				// chartText2.style.bottom = 103 + "%";

				if (helpers.isMobile()) {
					block_1.classList.remove("js-scrollanimation-text--active");
					// chart_1.chartWrapper.classList.add('charts-row--hidden');
				}
			}, // { progress, direction, isActive }
			// onLeave: () => {
			// 	block_2.classList.remove('js-scrollanimation-text--active');
			// },
			onLeaveBack: () => {
				block_2.classList.remove("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.add("charts-row--hidden");
				// chartText2.style.bottom = -50 + "%";
			},
			onUpdate(e) {
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + 30);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		if (helpers.isMobile()) {
			setTimeout(() => {
				document.querySelector(".js-desktop").remove();
			}, 5000);
		}

		return functionSTArr;
	} else {
		return [];
	}
}

// Schools animation js-schools-animation
function initSchoolsAnimation() {
	const chartBlockEl = document.querySelector(".js-schools-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley wrapper
		const trolleyWrapper = chartBlockEl.closest(".trolley-big");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");

		// Trigger distance from start of the block
		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];

		const title1 = chartBlockEl.querySelector('.chart-block__title[data-chart="1"]');
		const title2 = chartBlockEl.querySelector('.chart-block__title[data-chart="2"]');

		const show1ST = () => {
			title1.classList.remove("chart-block__title--hidden");
			title2.classList.add("chart-block__title--hidden");

			block_1.classList.add("js-scrollanimation-text--active");
			chart_1.chartWrapper.classList.remove("charts-row--hidden");
		}

		const hide1ST = () => {
			title1.classList.add("chart-block__title--hidden");
			title2.classList.remove("chart-block__title--hidden");

			block_1.classList.remove("js-scrollanimation-text--active");
			chart_1.chartWrapper.classList.add("charts-row--hidden");
		}

		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		helpers.setHeightChartDescription(textBlocksArr, chartBlockEl);

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		let distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock;
		if (helpers.isMobile()) {
			distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48;
		}
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');
		let chartText3 = chartBlockEl.querySelector('[data-chart="3"] .charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const speed = 1.8;
		const endPoint = chartBlockEl.clientHeight * 0.25;
		const endHPoint = (chartBlockEl.clientHeight + endPoint);

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			refreshPriority: 68,
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			invalidateOnRefresh: true,
			// id: "schools",
			// markers: true,
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll} center` : `top-=${pinOffset - 750} top`,
			// 	trolleyParentEl.classList.add('pin-spacer-capable')
			// },
			onEnter: () => {
			},
			onEnterBack: () => {
			},
			onLeave: () => {
				trolleyWrapper.classList.remove("trolley-custom");
			},
			onLeavBack: () => {
				trolleyWrapper.classList.remove("trolley-custom");
			},
			onToggle: ({isActive}) => {
				// if (isActive === true) {
				// 	// outter trolley-big
				// 	trolleyWrapper.classList.add('trolley-custom');
				// } else {
				// 	trolleyWrapper.classList.remove('trolley-custom');
				// }
			},
			onUpdate(e) {
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				if (helpers.isMobile()) {
					// chartTextBlockEl.style.transform = `translate3d(0, -${distanceToScroll * e.progress}px, 0)`;
				} else {
					// chartTextBlockEl.style.transform = position;
					chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll / speed) * e.progress}px, 0)`;
				}
			},
		});
		functionSTArr.push(sectionST);

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];


		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_1_pointer}"]`), columns: [],
		};
		const chart1Columns = chart_1.chartWrapper.querySelectorAll(".charts-col");
		chart1Columns.forEach((chart1Col, index) => {
			chart_1.columns.push({
				index,
				column: chart1Col,
				textValueEl: chart1Col.querySelector(".chart-value"),
				textCaptionEl: chart1Col.querySelector(".chart-caption"),
				mainCircle: chart1Col.querySelector(".chart-circle"),
				bgCircle: chart1Col.querySelector(".chart-circle__bg"),
				smallCircle: chart1Col.querySelector(".chart-circle__fill"),
				smallCircleDefaultScale: Math.sqrt(parseFloat(chart1Col
					.querySelector(".chart-circle__fill")
					.getAttribute("data-circle-scale"), 10)),
				bgCircleDefaultScale: Math.sqrt(parseFloat(chart1Col
					.querySelector(".chart-circle__bg")
					.getAttribute("data-circle-scale"), 10)),
			});
		});

		const text1ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 67,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${(block_1.clientHeight * speed)} center+=${endHPoint}` : `top-=${pinOffset - 300} top`,
			// id: 'p-111111',
			// markers: true,
			onEnter: ({progress}) => {
				console.log("enter 13");
				show1ST();
			},
			onEnterBack: ({progress}) => {
				console.log("enter 13onEnterBack");
				show1ST();
			},
			onLeave: ({progress, direction, isActive}) => {
				console.log("enter 13 onLeave");
				hide1ST();
			},
			onLeaveBack: () => {
				console.log("enter 13 onLeaveBack");
			},
			onUpdate(e) {
				// paragraph_1_animation(e.progress);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartEl.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text1ST);

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		const chart_2_pointer = block_2.getAttribute("data-to-chart");
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_2_pointer}"]`), columns: [],
		};
		const chart2Columns = chart_2.chartWrapper.querySelectorAll(".charts-col");
		chart2Columns.forEach((chart2Col, index) => {
			chart_2.columns.push({
				index,
				column: chart2Col,
				textValueEl: chart2Col.querySelector(".chart-value"),
				textCaptionEl: chart2Col.querySelector(".chart-caption"),
				mainCircle: chart2Col.querySelector(".chart-circle"),
				bgCircle: chart2Col.querySelector(".chart-circle__bg"),
				smallCircle: chart2Col.querySelector(".chart-circle__fill"),
				smallCircleDefaultScale: Math.sqrt(parseFloat(chart2Col
					.querySelector(".chart-circle__fill")
					.getAttribute("data-circle-scale"), 10)),
				bgCircleDefaultScale: Math.sqrt(parseFloat(chart2Col
					.querySelector(".chart-circle__bg")
					.getAttribute("data-circle-scale"), 10)),
			});
		});

		chart_2.legend = chartBlockEl.querySelector(`.chart-legend_caption-col[data-chart="${chart_2_pointer}"]`);
		chart_2.legend.style.opacity = `0`;
		chart_2.legend.style.transform = `translate3d(0, 0, 0)`;

		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 66,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top+=${(block_1.clientHeight * speed)} center+=${endHPoint}` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${(block_1.clientHeight * speed) + (block_2.clientHeight * speed)} center+=${endHPoint}` : `top-=${pinOffset - 600} top`,
			// markers: true,
			// id: 'p-2',
			onEnter: ({progress}) => {
				// console.log("enter 14");
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: ({progress}) => {
				// console.log("enter 14 onEnterBack");
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			},
			onLeave: ({progress, direction, isActive}) => {
				// console.log("enter 14 onLeave");
				block_2.classList.remove("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.add("charts-row--hidden");
			},
			onLeaveBack: () => {
				// console.log("enter 14 onLeaveBack");
				block_2.classList.remove("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.add("charts-row--hidden");
			},
			onUpdate(e) {
				paragraph_2_animation(e.progress);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartEl.offsetHeight);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		// Animation for the 3-rd paragraph
		const block_3 = textBlocksArr[2];
		// Animation for the second paragraph
		const chart_3_pointer = block_3.getAttribute("data-to-chart");
		const chart_3 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_3_pointer}"]`), columns: [],
		};
		const chart3Columns = chart_3.chartWrapper.querySelectorAll(".charts-col");
		chart3Columns.forEach((chart3Col, index) => {
			chart_3.columns.push({
				index,
				column: chart3Col,
				textValueEl: chart3Col.querySelector(".chart-value"),
				textCaptionEl: chart3Col.querySelector(".chart-caption"),
				mainCircle: chart3Col.querySelector(".chart-circle"),
				bgCircle: chart3Col.querySelector(".chart-circle__bg"),
				smallCircle: chart3Col.querySelector(".chart-circle__fill"),
				smallCircleDefaultScale: Math.sqrt(parseFloat(chart3Col
					.querySelector(".chart-circle__fill")
					.getAttribute("data-circle-scale"), 10)),
				smallCircleEndScale: Math.sqrt(parseFloat(chart3Col
					.querySelector(".chart-circle__fill")
					.getAttribute("data-circle-end-scale"), 10)),
			});
		});

		const text3ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 65,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top+=${(block_1.clientHeight * speed) + (block_2.clientHeight * speed)} center+=${endHPoint}` : `top-=${pinOffset - 600} top`,

			end: !helpers.isMobile() ? `top+=${(block_1.clientHeight * speed) + (block_2.clientHeight * speed) + (block_3.clientHeight * speed)} center+=${endHPoint}` : `top-=${pinOffset - 750} top`,
			// markers: true,
			// id: 'p-333333333',
			onEnter: ({progress}) => {
				console.log("enter 15");
				block_3.classList.add("js-scrollanimation-text--active");
				chart_3.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: ({progress}) => {
				block_3.classList.add("js-scrollanimation-text--active");
				chart_3.chartWrapper.classList.remove("charts-row--hidden");
			}, // onLeave: ({ progress, direction, isActive }) => {
			// 	block_3.classList.remove('js-scrollanimation-text--active');
			// },
			onLeaveBack: ({progress, direction, isActive}) => {
				block_3.classList.remove("js-scrollanimation-text--active");
				chart_3.chartWrapper.classList.add("charts-row--hidden");
			}, // onLeaveBack: ({ progress, direction, isActive }) => {
			// },
			onUpdate(e) {
				// paragraph_3_animation(e.progress);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartText2.offsetHeight + 30);

					chartText3.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text3ST);

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		function paragraph_1_animation(progress) {
			console.log('paragraph_1_animation');
			chart_1.columns.forEach((column) => {
				const scaleK = progress * column.bgCircleDefaultScale;

				// Scale bg cirlces
				column.bgCircle.style.transform = `scale3d(${scaleK}, ${scaleK}, 1)`;
			});
		}

		// Second text block related animation
		function paragraph_2_animation(progress) {
			// console.log('paragraph_2_animation');
			// chart_2.columns.forEach((column) => {
			// 	// const opacity = clamp(progress, 0.05, 1);
			// 	const scaleK = clamp(column.bgCircleDefaultScale + progress, column.bgCircleDefaultScale, 1);

			// 	// Scale bg cirlces
			// 	column.bgCircle.style.transform = `scale3d(${scaleK}, ${scaleK}, 1)`;
			// });

			let num = (1 - progress) * 30;
			chart_2.legend.style.opacity = String(progress * 2);

			if (0 > num) {
				chart_2.legend.style.transform = `translate3d(0, ${num}%, 0)`;
			}


		}

		// 3-rd text block related animation
		function paragraph_3_animation(progress) {
			console.log('paragraph_3_animation');
			chart_3.columns.forEach((column) => {
				const delta = Math.pow(column.smallCircleEndScale, 2) - Math.pow(column.smallCircleDefaultScale, 2);
				const scaleK = column.smallCircleEndScale + delta * progress;

				// Scale bg cirlces
				column.smallCircle.style.transform = `scale3d(${scaleK}, ${scaleK}, 1)`;
			});
		}

		return functionSTArr;
	} else {
		return [];
	}
}


// Schools animation js-schools-animation
function initProcessAnimation() {
	const chartBlockEl = document.querySelector(".js-process-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley block
		const trolleyWrapper = chartBlockEl.closest(".trolley");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");
		const triggerEl = document.querySelector(".js-trigger-process");
		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48 * 3;
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			trigger: !helpers.isMobile() ? triggerEl : chartBlockEl,
			refreshPriority: 58,
			invalidateOnRefresh: true,
			id: "doctors-2",
			markers: false,
			start: !helpers.isMobile() ? `top-=${chartWrapperEl.clientHeight} center` : `top-=${pinOffset} top`,
			// start: !helpers.isMobile() ? `top-=${chartWrapperEl.clientHeight + (chartWrapperEl.clientHeight * 0.65)} center` : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll} center` : `top-=${pinOffset - 450} top`,
			onUpdate(e) {
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				if (helpers.isMobile()) {
					chartTextBlockEl.style.transform = `translate3d(0, -${distanceToScroll * e.progress}px, 0)`;
				} else {
					chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll / 1.8) * e.progress}px, 0)`;
				}
			},

			// pin: chartBlockEl,
		});
		functionSTArr.push(sectionST);

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		// const chart_1 =
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_1_pointer}"]`), columns: [],
		};
		const chart1Columns = chart_1.chartWrapper.querySelectorAll(".charts-subrow");
		chart1Columns.forEach((chart1Col, index) => {
			chart_1.columns.push({
				index, column: chart_1, textValueEl: chart1Col.querySelector(".charts-subrow__value"),
			});
		});
		let stepParam = helpers.isMobile ? 200 : 0;
		const text1ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 57,
			invalidateOnRefresh: true,
			// markers: true,
			id: 'p-1',
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${(block_1.clientHeight - gapFromStartOfTheBlock) / 2} top` : `top-=${pinOffset - 300} top`,
			onEnter: () => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove('charts-row--hidden');
			},
			onEnterBack: () => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove('charts-row--hidden');
			},
			onLeave: () => {
				block_1.classList.remove("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.add('charts-row--hidden');
			},
			onLeaveBack: () => {
				block_1.classList.add("js-scrollanimation-text--active");
			},
			onUpdate(e) {
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text1ST);

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		const chart_2_pointer = block_2.getAttribute("data-to-chart");
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_2_pointer}"]`), columns: [],
		};
		const chart2Columns = chart_2.chartWrapper.querySelectorAll(".charts-subrow");
		chart2Columns.forEach((chart2Col, index) => {
			chart_2.columns.push({
				index,
				column: chart2Col,
				bgCircle: chart2Col.querySelector(".chart-circle__bg"),
				textValueEl: chart2Col.querySelector(".charts-subrow__value"),
			});
		});

		// Legend
		chart_2.legend = chartBlockEl.querySelector(`.chart-legend_caption-col .chart-legend_caption[data-chart="${chart_2_pointer}"]`);


		// chart_2.columns.forEach((column) => {
		// 	column.bgCircle.style.transform = `scale3d(0, 0, 1)`;
		//
		// 	column.textValueEl.style.opacity = String(0);
		// });

		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 56,
			invalidateOnRefresh: true,
			// markers: true,
			id: 'p-2',
			start: !helpers.isMobile() ? `top+=${(block_2.offsetTop - gapFromStartOfTheBlock - stepParam)} top` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock - stepParam} center` : `top-=${pinOffset - 450} top`,
			onEnter: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove('charts-row--hidden');
			},
			onEnterBack: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove('charts-row--hidden');
			},
			onLeaveBack: () => {
				block_2.classList.remove("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.add('charts-row--hidden');
			},
			onUpdate(e) {
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartText2.offsetHeight + 30);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		// Second text block related animation
		return functionSTArr;
	} else {
		return [];
	}
}

function initProcess2Animation() {
	const chartBlockEl = document.querySelector(".js-process2-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley block
		const trolleyWrapper = chartBlockEl.closest(".trolley");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");
		const triggerEl = document.querySelector(".js-trigger2-process");
		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48 * 3;
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			trigger: !helpers.isMobile() ? triggerEl : chartBlockEl,
			refreshPriority: 58,
			invalidateOnRefresh: true,
			id: "doctors-3",
			markers: false,
			start: !helpers.isMobile() ? `top-=${chartWrapperEl.clientHeight - (chartWrapperEl.clientHeight * 0.05)} center` : `top-=${pinOffset} top`,
			// start: !helpers.isMobile() ? "center bottom" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll} center` : `top-=${pinOffset - 600} top`,
			onUpdate(e) {
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				if (helpers.isMobile()) {
					chartTextBlockEl.style.transform = `translate3d(0, -${distanceToScroll * e.progress}px, 0)`;
				} else {
					chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll / 1.8) * e.progress}px, 0)`;
				}
			},

			// pin: chartBlockEl,
		});
		functionSTArr.push(sectionST);

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		// const chart_1 =
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_1_pointer}"]`), columns: [],
		};
		const chart1Columns = chart_1.chartWrapper.querySelectorAll(".charts-subrow");
		chart1Columns.forEach((chart1Col, index) => {
			chart_1.columns.push({
				index, column: chart_1, textValueEl: chart1Col.querySelector(".charts-subrow__value"),
			});
		});
		let stepParam = helpers.isMobile ? 200 : 0;
		const text1ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 57,
			invalidateOnRefresh: true,
			markers: false, // id: 'p-1',
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${(block_1.clientHeight - gapFromStartOfTheBlock) / 2} top` : `top-=${pinOffset - 300} top`,
			onEnter: () => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove('charts-row--hidden');
			},
			onEnterBack: () => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove('charts-row--hidden');
			},
			onLeave: () => {
				block_1.classList.remove("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.add('charts-row--hidden');
			},
			onLeaveBack: () => {
				block_1.classList.add("js-scrollanimation-text--active");
			},
			onUpdate(e) {
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text1ST);

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		const chart_2_pointer = block_2.getAttribute("data-to-chart");
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_2_pointer}"]`), columns: [],
		};
		const chart2Columns = chart_2.chartWrapper.querySelectorAll(".charts-subrow");
		chart2Columns.forEach((chart2Col, index) => {
			chart_2.columns.push({
				index,
				column: chart2Col,
				bgCircle: chart2Col.querySelector(".chart-circle__bg"),
				textValueEl: chart2Col.querySelector(".charts-subrow__value"),
			});
		});

		// Legend
		chart_2.legend = chartBlockEl.querySelector(`.chart-legend_caption-col .chart-legend_caption[data-chart="${chart_2_pointer}"]`);


		// chart_2.columns.forEach((column) => {
		// 	column.bgCircle.style.transform = `scale3d(0, 0, 1)`;
		//
		// 	column.textValueEl.style.opacity = String(0);
		// });

		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 56,
			invalidateOnRefresh: true, // markers: false,
			// id: 'p-2',
			start: !helpers.isMobile() ? `top+=${(block_2.offsetTop - gapFromStartOfTheBlock - stepParam * 2)} top` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock + 50} center` : `top-=${pinOffset - 600} top`,
			onEnter: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove('charts-row--hidden');
			},
			onEnterBack: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove('charts-row--hidden');
			},
			onLeaveBack: () => {
				block_2.classList.remove("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.add('charts-row--hidden');
			},
			onUpdate(e) {
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		// Second text block related animation
		return functionSTArr;
	} else {
		return [];
	}
}

function initZurichStudentsAnimation() {
	const chartBlockEl = document.querySelector(".js-zurich-students-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley wrapper
		const trolleyWrapper = chartBlockEl.closest(".trolley");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");

		// Trigger distance from start of the block
		const chartsElementsArr = chartEl.querySelectorAll(".bar-chart__area");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".chartbar"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock + 16;
		// const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48;
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			refreshPriority: 64,
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			invalidateOnRefresh: true,
			id: "schools-1",
			markers: false,
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll} center` : `top-=${pinOffset - 600} top`,
			// 	trolleyParentEl.classList.add('pin-spacer-capable')
			// },
			onEnter: () => {
			},
			onEnterBack: () => {
			},
			onLeave: () => {
				trolleyWrapper.classList.remove("trolley-custom");
			},
			onLeavBack: () => {
				trolleyWrapper.classList.remove("trolley-custom");
			},
			onToggle: ({isActive}) => {
				// if (isActive === true) {
				// 	// outter trolley-big
				// 	trolleyWrapper.classList.add('trolley-custom');
				// } else {
				// 	trolleyWrapper.classList.remove('trolley-custom');
				// }
			},
			onUpdate(e) {
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				if (helpers.isMobile()) {
					chartTextBlockEl.style.transform = `translate3d(0, -${distanceToScroll * e.progress}px, 0)`;
				} else {
					chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll / 1.8) * e.progress}px, 0)`;
				}
			},
		});
		functionSTArr.push(sectionST);

		// Chart's annotations
		const chartsXMarksArr = chartBlockEl.querySelectorAll(".bar-chart__scale-mark");
		const chartsYMarksArr = chartBlockEl.querySelectorAll(".bar-chart__plot-mark");
		const chartsYLinesArr = chartBlockEl.querySelectorAll(".bar-chart__plot-line");

		// chartsXMarksArr.forEach((chartsXMark) => {
		// 	chartsXMark.style.opacity = 0;
		// });
		chartsYMarksArr.forEach((chartsYMark) => {
			chartsYMark.style.opacity = 0;
		});
		chartsYLinesArr.forEach((chartsYLine) => {
			chartsYLine.style.transform = `scale3d(1, 1, 1)`;
		});

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.bar-chart__area[data-chart="${chart_1_pointer}"]`), columns: [],
		};
		const chart1Columns = chart_1.chartWrapper.querySelectorAll(".chartbar");
		chart1Columns.forEach((chart1Col, index) => {
			const fractionGroupArr = [];
			const fractionsArr = chart1Col.querySelectorAll(".chartbar__fraction");

			fractionsArr.forEach((fraction) => {
				fractionGroupArr.push({
					fraction: fraction,
					fractionBgEl: fraction.querySelector(".chartbar__fraction-bg"),
					fractionTextEl: fraction.querySelector(".chartbar__fraction-text"),
				});
			});

			chart_1.bigBgEl = chart1Col.querySelector(".chartbar__big-bg");

			chart_1.columns.push({
				index,
				column: chart1Col,
				defaultBarScale: parseFloat(chart1Col.getAttribute("data-chartbar-bar"), 10),
				chartBarFractionsGroup: fractionGroupArr,
			});
		});

		const chartArea1 = chartEl.querySelector(".bar-chart__area[data-chart='1']");
		const chartArea2 = chartEl.querySelector(".bar-chart__area[data-chart='2']");
		const chartScaleX = chartEl.querySelector(".bar-chart__scale-x");
		const chartScaleY = chartEl.querySelector(".bar-chart__scale-y");

		const showChart1 = () => {
			chartArea1.classList.remove("bar-chart__area--hidden");
		}

		const hideChart1 = () => {
			chartArea1.classList.add("bar-chart__area--hidden");
		}

		const showChart2 = () => {
			chartArea2.classList.remove("bar-chart__area--hidden");
			// chartScaleX.classList.remove("bar-chart__area--hidden");
			chartsXMarksArr.forEach((chartsXMark) => {
				chartsXMark.classList.remove("bar-chart__area--hidden");
			});
			chartScaleY.classList.remove("bar-chart__area--hidden");
		}

		const hideChart2 = () => {
			chartArea2.classList.add("bar-chart__area--hidden");
			// chartScaleX.classList.add("bar-chart__area--hidden");
			chartsXMarksArr.forEach((chartsXMark) => {
				chartsXMark.classList.add("bar-chart__area--hidden");
			});
			chartScaleY.classList.add("bar-chart__area--hidden");
		}

		if (helpers.isMobile()) {
			chartText1.style.top = `${chartBlockEl.offsetHeight - (chartEl.offsetTop + chartWrapperEl.offsetTop + chartsElementsArr[0].offsetHeight) + chartsElementsArr[0].offsetHeight}px`;
		}

		const text1ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 63,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top center` : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${block_1.clientHeight - gapFromStartOfTheBlock / 2} center` : `top-=${pinOffset - 300} top`,
			// id: 'p-1',
			// markers: true,
			onEnter: ({progress}) => {
				console.log("enter 20");
				showChart1();
				hideChart2();
				block_1.classList.add("js-scrollanimation-text--active");
				// chart_1.chartWrapper.classList.remove('bar-chart__area--hidden');
			},
			onEnterBack: ({progress}) => {
				console.log("enter 20 onEnterBack");
				// chartArea1.classList.remove("bar-chart__area--hidden");
				block_1.classList.add("js-scrollanimation-text--active");
				// chart_1.chartWrapper.classList.remove('bar-chart__area--hidden');
			},
			onLeave: ({progress, direction, isActive}) => {
				console.log("enter 20 onLeave");
				block_1.classList.remove("js-scrollanimation-text--active");
				// chart_1.chartWrapper.classList.add('bar-chart__area--hidden');
			},
			onRefresh(e) {
				if (helpers.isMobile()) {
					chartText1.style.top = `${chartBlockEl.offsetHeight - (chartEl.offsetTop + chartWrapperEl.offsetTop + chartsElementsArr[0].offsetHeight) + chartsElementsArr[0].offsetHeight}px`;
				}
			},
			onUpdate(e) {
				// paragraph_1_animation(e.progress);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text1ST);

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		const chart_2_pointer = block_2.getAttribute("data-to-chart");
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.bar-chart__area[data-chart="${chart_2_pointer}"]`), columns: [],
		};
		const chart2Columns = chart_2.chartWrapper.querySelectorAll(".chartbar");
		chart2Columns.forEach((chart2Col, index) => {
			const fractionGroupArr = [];
			const fractionsArr = chart2Col.querySelectorAll(".chartbar__fraction");

			fractionsArr.forEach((fraction) => {
				fractionGroupArr.push({
					fraction: fraction, fractionBgEl: fraction.querySelector(".chartbar__fraction-bg"),
				});
			});

			chart_2.columns.push({
				index,
				column: chart2Col,
				bigBgEl: chart2Col.querySelector(".chartbar__big-bg"),
				defaultBarScale: parseFloat(chart2Col.getAttribute("data-chartbar-bar"), 10), // fractionsArr: fractionsArr,
				chartBarFractionsGroup: fractionGroupArr,
			});
		});

		paragraph_2_animation(1);

		// Set initial scale 0 to bg cirlces in animation
		chart_2.columns.forEach((column) => {
			// Scale down bars cirlces
			chart_2.columns.forEach((column) => {
				column.bigBgEl.style.transform = `scale3d(1, 0%, 1)`;

				column.chartBarFractionsGroup.forEach((fractionGroup) => {
					fractionGroup.fractionBgEl.style.transform = `scale3d(1, 0%, 1)`;
				});
			});
		});

		paragraph_2_animation(0.99);

		if (helpers.isMobile()) {
			chartText2.style.top = `${chartBlockEl.offsetHeight - (chartEl.offsetTop + chartWrapperEl.offsetTop + chartsElementsArr[0].offsetHeight) + chartsElementsArr[1].offsetHeight}px`;
		}

		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 62,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top+=${block_2.offsetTop - gapFromStartOfTheBlock / 2} center` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock} center` : `top-=${pinOffset - 600} top`,
			// markers: true,
			// id: 'p-2',
			onEnter: ({progress}) => {
				console.log("enter 201");
				block_2.classList.add("js-scrollanimation-text--active");
				hideChart1();
				showChart2();
				// chart_2.chartWrapper.classList.remove('bar-chart__area--hidden');
			},
			onEnterBack: ({progress}) => {
				console.log("enter 201 onEnterBack");
				block_2.classList.add("js-scrollanimation-text--active");
				// chart_2.chartWrapper.classList.remove('bar-chart__area--hidden');
			},
			onLeaveBack: ({progress, direction, isActive}) => {
				console.log("enter 201 onLeaveBack");
				hideChart2();
				showChart1();
				block_2.classList.remove("js-scrollanimation-text--active");
				// chart_2.chartWrapper.classList.add('bar-chart__area--hidden');
			},
			onRefresh(e) {
				if (helpers.isMobile()) {
					chartText2.style.top = `${chartBlockEl.offsetHeight - (chartEl.offsetTop + chartWrapperEl.offsetTop + chartsElementsArr[0].offsetHeight) + chartsElementsArr[1].offsetHeight}px`;
				}
			},
			onUpdate(e) {
				// console.log(e.progress);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartEl.offsetHeight + chartText2.offsetHeight + 60);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		function paragraph_1_animation(progress) {
			const stepProgress = 1 - progress;

			chart_1.bigBgEl.style.transform = `scale3d(1, ${stepProgress * 100}%, 1)`;

			chart_1.columns.forEach((column) => {
				column.chartBarFractionsGroup.forEach((fractionGroup) => {
					fractionGroup.fractionTextEl.style.opacity = `${stepProgress * 100}%`;
					fractionGroup.fractionBgEl.style.transform = `scale3d(1, ${stepProgress * 100}%, 1)`;
				});
			});
		}

		// Second text block related animation
		function paragraph_2_animation(progress) {
			console.log(progress);
			// chartsXMarksArr.forEach((chartsXMark) => {
			// 	chartsXMark.style.opacity = progress;
			// });
			chartsYMarksArr.forEach((chartsYMark) => {
				chartsYMark.style.opacity = progress;
			});
			// chartsYLinesArr.forEach((chartsYLine) => {
			// 	chartsYLine.style.transform = `scale3d(${progress}, 1, 1)`;
			// });

			chart_2.columns.forEach((column) => {
				column.bigBgEl.style.transform = `scale3d(1, ${progress * 100}%, 1)`;

				column.chartBarFractionsGroup.forEach((fractionGroup) => {
					fractionGroup.fractionBgEl.style.transform = `scale3d(1, ${progress * 100}%, 1)`;
				});
			});
		}

		return functionSTArr;
	} else {
		return [];
	}
}

function initMassProtestsAnimation() {
	const chartBlockEl = document.querySelector(".js-mass-protests-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley wrapper
		const trolleyWrapper = chartBlockEl.closest(".trolley");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");

		// Trigger distance from start of the block
		const chartsElementsArr = chartEl.querySelectorAll(".bar-chart__area");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".chartbar"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock + 16;
		// const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48;
		let chartText1 = chartBlockEl.querySelector('.charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		if (helpers.isMobile()) {
			const sectionST = ScrollTrigger.create({
				pin: trolleyWrapper,
				refreshPriority: 49,
				trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
				invalidateOnRefresh: true,
				id: "mass-protests",
				markers: false,
				start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
				end: !helpers.isMobile() ? `top+=${distanceToScroll} center` : `top-=${pinOffset - 300} top`,
				// 	trolleyParentEl.classList.add('pin-spacer-capable')
				// },
				onEnter: () => {
				},
				onEnterBack: () => {
				},
				onLeave: () => {
					trolleyWrapper.classList.remove("trolley-custom");
				},
				onLeavBack: () => {
					trolleyWrapper.classList.remove("trolley-custom");
				},
				onToggle: ({isActive}) => {
					// if (isActive === true) {
					// 	// outter trolley-big
					// 	trolleyWrapper.classList.add('trolley-custom');
					// } else {
					// 	trolleyWrapper.classList.remove('trolley-custom');
					// }
				},
				onUpdate(e) {
					// scrollToTopBlock(e.progress, chartTextBlockEl);
					if (helpers.isMobile()) {
						chartTextBlockEl.style.transform = `translate3d(0, -${distanceToScroll * e.progress}px, 0)`;
					} else {
						// chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll / 1.8) * e.progress}px, 0)`;
					}
				},
			});
			functionSTArr.push(sectionST);
		}

		// Chart's annotations
		const chartsXMarksArr = chartBlockEl.querySelectorAll(".bar-chart__scale-mark");
		const chartsYMarksArr = chartBlockEl.querySelectorAll(".bar-chart__plot-mark");
		const chartsYLinesArr = chartBlockEl.querySelectorAll(".bar-chart__plot-line");

		chartsXMarksArr.forEach((chartsXMark) => {
			chartsXMark.style.opacity = 0;
		});
		chartsYMarksArr.forEach((chartsYMark) => {
			chartsYMark.style.opacity = 0;
		});
		chartsYLinesArr.forEach((chartsYLine) => {
			chartsYLine.style.transform = `scale3d(0, 1, 1)`;
		});

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.bar-chart__area[data-chart="${chart_1_pointer}"]`), columns: [],
		};
		// const chart1Columns = chart_1.chartWrapper.querySelectorAll(".chartbar");
		// chart1Columns.forEach((chart1Col, index) => {
		// 	const fractionGroupArr = [];
		// 	const fractionsArr = chart1Col.querySelectorAll(".chartbar__fraction");
		//
		// 	fractionsArr.forEach((fraction) => {
		// 		fractionGroupArr.push({
		// 			fraction: fraction,
		// 			fractionBgEl: fraction.querySelector(".chartbar__fraction-bg"),
		// 			fractionTextEl: fraction.querySelector(".chartbar__fraction-text"),
		// 		});
		// 	});
		//
		// 	chart_1.bigBgEl = chart1Col.querySelector(".chartbar__big-bg");
		//
		// 	chart_1.columns.push({
		// 		index,
		// 		column: chart1Col,
		// 		defaultBarScale: parseFloat(chart1Col.getAttribute("data-chartbar-bar"), 10),
		// 		chartBarFractionsGroup: fractionGroupArr,
		// 	});
		// });

		if (helpers.isMobile()) {
			const text1ST = ScrollTrigger.create({
				trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
				refreshPriority: 48,
				invalidateOnRefresh: true,
				start: !helpers.isMobile() ? `top center` : `top-=${pinOffset} top`,
				end: !helpers.isMobile() ? `top+=${block_1.clientHeight - gapFromStartOfTheBlock / 2} center` : `top-=${pinOffset - 300} top`,
				markers: false,
				onEnter: ({progress}) => {
					console.log("enter 20");
					block_1.classList.add("js-scrollanimation-text--active");
					// chart_1.chartWrapper.classList.remove('bar-chart__area--hidden');
				},
				onEnterBack: ({progress}) => {
					block_1.classList.add("js-scrollanimation-text--active");
					// chart_1.chartWrapper.classList.remove('bar-chart__area--hidden');
				},
				onLeave: ({progress, direction, isActive}) => {
					block_1.classList.remove("js-scrollanimation-text--active");
					// chart_1.chartWrapper.classList.add('bar-chart__area--hidden');
				},
				onUpdate(e) {
					// paragraph_1_animation(e.progress);

					if (helpers.isMobile()) {
						const progress = -e.progress * (chartEl.offsetHeight + chartText1.offsetHeight + 70);

						chartText1.style.transform = `translateY(${progress}px)`;
					}
				},
			});
			functionSTArr.push(text1ST);
		}

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		const chart_2_pointer = 2;
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.bar-chart__area[data-chart="${chart_2_pointer}"]`), columns: [],
		};
		const chart2Columns = chart_2.chartWrapper.querySelectorAll(".chartbar");
		chart2Columns.forEach((chart2Col, index) => {
			const fractionGroupArr = [];
			const fractionsArr = chart2Col.querySelectorAll(".chartbar__fraction");

			fractionsArr.forEach((fraction) => {
				fractionGroupArr.push({
					fraction: fraction, fractionBgEl: fraction.querySelector(".chartbar__fraction-bg"),
				});
			});

			chart_2.columns.push({
				index,
				column: chart2Col,
				bigBgEl: chart2Col.querySelector(".chartbar__big-bg"),
				defaultBarScale: parseFloat(chart2Col.getAttribute("data-chartbar-bar"), 10), // fractionsArr: fractionsArr,
				chartBarFractionsGroup: fractionGroupArr,
			});
		});

		// Set initial scale 0 to bg cirlces in animation
		chart_2.columns.forEach((column) => {
			// Scale down bars cirlces
			chart_2.columns.forEach((column) => {
				column.bigBgEl.style.transform = `scale3d(1, 0%, 1)`;

				column.chartBarFractionsGroup.forEach((fractionGroup) => {
					fractionGroup.fractionBgEl.style.transform = `scale3d(1, 0%, 1)`;
				});
			});
		});

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		function paragraph_1_animation(progress) {
			const stepProgress = 1 - progress;

			chart_1.bigBgEl.style.transform = `scale3d(1, ${stepProgress * 100}%, 1)`;

			chart_1.columns.forEach((column) => {
				column.chartBarFractionsGroup.forEach((fractionGroup) => {
					fractionGroup.fractionTextEl.style.opacity = `${stepProgress * 100}%`;
					fractionGroup.fractionBgEl.style.transform = `scale3d(1, ${stepProgress * 100}%, 1)`;
				});
			});
		}

		// Second text block related animation
		function paragraph_2_animation(progress) {
			chartsXMarksArr.forEach((chartsXMark) => {
				chartsXMark.style.opacity = progress;
			});
			chartsYMarksArr.forEach((chartsYMark) => {
				chartsYMark.style.opacity = progress;
			});
			chartsYLinesArr.forEach((chartsYLine) => {
				chartsYLine.style.transform = `scale3d(${progress}, 1, 1)`;
			});

			chart_2.columns.forEach((column) => {
				column.bigBgEl.style.transform = `scale3d(1, ${progress * 100}%, 1)`;

				column.chartBarFractionsGroup.forEach((fractionGroup) => {
					fractionGroup.fractionBgEl.style.transform = `scale3d(1, ${progress * 100}%, 1)`;
				});
			});
		}

		return functionSTArr;
	} else {
		return [];
	}
}

function initDoctorsAnimation() {
	const chartBlockEl = document.querySelector(".js-doctors-chart");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley block
		const trolleyWrapper = chartBlockEl.closest(".trolley");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");

		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48;
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			refreshPriority: 61,
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			invalidateOnRefresh: true,
			id: "doctors",
			markers: false,
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll} center` : `top-=${pinOffset - 600} top`,
			onUpdate(e) {
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				if (helpers.isMobile()) {
					chartTextBlockEl.style.transform = `translate3d(0, -${distanceToScroll * e.progress}px, 0)`;
				} else {
					chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll / 1.8) * e.progress}px, 0)`;
				}
			},
			onLeave: () => {
				trolleyWrapper.classList.remove("trolley-custom");
			},
			onLeavBack: () => {
				trolleyWrapper.classList.remove("trolley-custom");
			}, // pin: chartBlockEl,
		});
		functionSTArr.push(sectionST);

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		// const chart_1 =
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_1_pointer}"]`),
		};
		chart_1.mainCircle = chart_1.chartWrapper.querySelector(".chart-circle");
		chart_1.bgCircle = chart_1.mainCircle.querySelector(".chart-circle__bg");
		chart_1.smallCircle = chart_1.mainCircle.querySelector(".chart-circle__fill");
		chart_1.text = chart_1.smallCircle.querySelector(".chart-circle__graph-text");
		chart_1.smallCircleDefaultScale = Math.sqrt(parseFloat(chart_1.smallCircle.getAttribute("data-circle-scale"), 10));
		chart_1.legend = chartBlockEl.querySelector(`.chart-legend_caption-col[data-chart="${chart_1_pointer}"]`);
		let stepParam = helpers.isMobile ? 200 : 0;
		const textST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 60,
			invalidateOnRefresh: true,
			markers: false, // id: 'p-1',
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${block_1.clientHeight} center` : `top-=${pinOffset - 300} top`,
			onEnter: () => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove('charts-row--hidden');
			},
			onEnterBack: () => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove('charts-row--hidden');
			},
			onLeave: () => {
				block_1.classList.remove("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.add('charts-row--hidden');
			},
			onLeaveBack: () => {
				block_1.classList.add("js-scrollanimation-text--active");
			},
			onUpdate(e) {
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(textST);

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		const chart_2_pointer = block_2.getAttribute("data-to-chart");
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_2_pointer}"]`), subrows: [],
		};
		const chart2Subrow = chart_2.chartWrapper.querySelectorAll(".charts-subrow");
		chart2Subrow.forEach((chart2Subrow, index) => {
			chart_2.subrows.push({
				index,
				subrow: chart2Subrow,
				mainCircle: chart2Subrow.querySelector(".js-chat-circle"), // mainCircle: chart2Subrow.querySelector('.chart-circle__graph'),
				mainCircleDefaultScale: Math.sqrt(parseFloat(chart2Subrow
					.querySelector(".chart-circle__graph")
					.getAttribute("data-circle-scale"), 10)),
				valueEl: chart2Subrow.querySelector(".chart-circle__text"),
				captionEl: chart2Subrow.querySelector(".charts-subrow__caption"),
			});
		});
		chart_2.legend = chartBlockEl.querySelector(`.chart-legend_caption-col .chart-legend_caption[data-chart="${chart_2_pointer}"]`);
		// chart_2.legend.style.opacity = `0`;
		// chart_2.legend.style.transform = `translate3d(0, 70%, 0)`;

		// Transform initial circles
		// chart_2.subrows.forEach((subrow) => {
		// 	Move circle on a delta
		// 	const deltaDistance = Math.round(chart_2.chartWrapper.clientHeight / 2) - subrow.subrow.offsetTop - subrow.mainCircle.clientHeight / 2;
		// 	subrow.mainCircle.style.transform = `translate3d(0, ${deltaDistance}px, 0)`;
		//
		// 	subrow.valueEl.style.opacity = String(0);
		// 	subrow.captionEl.style.opacity = String(0);
		// });

		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 59,
			invalidateOnRefresh: true, // markers: false,
			// id: 'p-2',
			start: !helpers.isMobile() ? `top+=${block_2.offsetTop} center` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock} center` : `top-=${pinOffset - 600} top`,
			onEnter: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove('charts-row--hidden');
			},
			onEnterBack: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove('charts-row--hidden');
			},
			onLeaveBack: () => {
				block_2.classList.remove("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.add('charts-row--hidden');
			},
			onUpdate(e) {
				paragraph_2_animation(e.progress);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartEl.offsetHeight + chartText2.offsetHeight + 50);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		// Second text block related animation
		function paragraph_2_animation(progress) {
			// const reverseOpacity = clamp(1 - progress * 2, 0, 1);
			// chart_1.chartWrapper.style.opacity = `${reverseOpacity * 100}%`;
			//
			// const columnsArrLength = chart_2.subrows.length;

			// Move legend
			chart_2.legend.style.opacity = String(1 - progress);

			// chart_2.subrows.forEach((subrow) => {
			// 	const valueOpacity = clamp(progress * (columnsArrLength - subrow.index), 0, 1);
			// 	const captionsOpacity = clamp(progress * (columnsArrLength - subrow.index), 0, 0.8);
			// 	// const particleCaptionsOpacity = clamp(progress * (columnsArrLength - subrow.index), 0, 0.5);
			//
			// 	subrow.valueEl.style.opacity = String(valueOpacity);
			// 	subrow.captionEl.style.opacity = String(captionsOpacity);
			//
			// 	// Move circle on a delta
			// 	const deltaDistance = Math.round(chart_2.chartWrapper.clientHeight / 2) - subrow.subrow.offsetTop - subrow.mainCircle.clientHeight / 2;
			// 	const deltaCircle = deltaDistance * (1 - progress);
			// 	// subrow.subrow.style.transform = `translate3d(0, ${deltaCircle}px, 0)`;
			// 	subrow.mainCircle.style.transform = `translate3d(0, ${deltaCircle}px, 0)`;
			// 	// subrow.mainCircle.style.transform = `scale3d(${subrow.mainCircleDefaultScale}, ${subrow.mainCircleDefaultScale}, 1) translate3d(0, ${deltaCircle}px, 0)`;
			// });
		}

		return functionSTArr;
	} else {
		return [];
	}
}

function initSpheresAnimation() {
	const chartBlockEl = document.querySelector(".js-spheres-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley block
		const trolleyWrapper = chartBlockEl.closest(".trolley");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");
		const triggerEl = document.querySelector(".js-trigger-shpere");
		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		let distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48 * 3;

		if (helpers.isMobile()) {
			distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48;
		}
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			trigger: !helpers.isMobile() ? triggerEl : chartBlockEl,
			refreshPriority: 58,
			invalidateOnRefresh: true,
			// id: "doctors-1",
			// markers: true,
			start: !helpers.isMobile() ? `top-=${chartWrapperEl.clientHeight - (chartWrapperEl.clientHeight * 0.1)} center` : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll} center` : `top-=${pinOffset - 600} top`,
			onUpdate(e) {
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				if (helpers.isMobile()) {
					chartTextBlockEl.style.transform = `translate3d(0, -${distanceToScroll * e.progress}px, 0)`;
				} else {
					chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll / 1.8) * e.progress}px, 0)`;
				}
			},

			// pin: chartBlockEl,
		});
		functionSTArr.push(sectionST);

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		// const chart_1 =
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_1_pointer}"]`), columns: [],
		};
		const chart1Columns = chart_1.chartWrapper.querySelectorAll(".charts-subrow");
		// chart1Columns.forEach((chart1Col, index) => {
		// 	chart_1.columns.push({
		// 		index, column: chart_1, textValueEl: chart1Col.querySelector(".charts-subrow__value"),
		// 	});
		// });
		let stepParam = helpers.isMobile ? 200 : 0;
		const text1ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 57,
			invalidateOnRefresh: true,
			markers: false,
			id: 'p-1',
			start: !helpers.isMobile() ? "top center" : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${block_1.clientHeight - gapFromStartOfTheBlock / 2} center` : `top-=${pinOffset - 300} top`,
			onEnter: () => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove('charts-row--hidden');
			},
			onEnterBack: () => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove('charts-row--hidden');
			},
			onLeave: () => {
				block_1.classList.remove("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.add('charts-row--hidden');
			},
			onLeaveBack: () => {
				block_1.classList.add("js-scrollanimation-text--active");
			},
			onUpdate(e) {
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text1ST);

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		const chart_2_pointer = block_2.getAttribute("data-to-chart");
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_2_pointer}"]`), columns: [],
		};
		const chart2Columns = chart_2.chartWrapper.querySelectorAll(".charts-subrow");
		// chart2Columns.forEach((chart2Col, index) => {
		// 	chart_2.columns.push({
		// 		index,
		// 		column: chart2Col,
		// 		bgCircle: chart2Col.querySelector(".chart-circle__bg"),
		// 		textValueEl: chart2Col.querySelector(".charts-subrow__value"),
		// 	});
		// });

		// Legend
		chart_2.legend = chartBlockEl.querySelector(`.chart-legend_caption-col .chart-legend_caption[data-chart="${chart_2_pointer}"]`);
		chart_2.legend.style.opacity = `0`;

		// chart_2.columns.forEach((column) => {
		// 	column.bgCircle.style.transform = `scale3d(0, 0, 1)`;
		//
		// 	column.textValueEl.style.opacity = String(0);
		// });

		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 56,
			invalidateOnRefresh: true, // markers: false,
			// id: 'p-2',
			start: !helpers.isMobile() ? `top+=${block_2.offsetTop - gapFromStartOfTheBlock / 2} center` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock} center` : `top-=${pinOffset - 600} top`,
			onEnter: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove('charts-row--hidden');
			},
			onEnterBack: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove('charts-row--hidden');
			},
			onLeaveBack: () => {
				block_2.classList.remove("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.add('charts-row--hidden');
			},
			onUpdate(e) {
				paragraph_2_animation(e.progress);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartEl.offsetHeight + chartText2.offsetHeight + 50);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		// Second text block related animation
		function paragraph_2_animation(progress) {
			const fastOpacity = clamp(progress * 2, 0, 1);
			const reverseOpacity = clamp(1 - progress * 2, 0, 1);
			// chart_1.chartWrapper.style.opacity = `${reverseOpacity * 100}%`;

			// const columnsArrLength = chart_2.subrows.length;
			chart_2.columns.forEach((column) => {
				column.bgCircle.style.transform = `scale3d(${progress}, ${progress}, 1)`;

				column.textValueEl.style.opacity = String(fastOpacity);
			});

			chart_1.columns.forEach((column) => {
				column.textValueEl.style.opacity = String(reverseOpacity);
			});

			// Move legend
			chart_2.legend.style.opacity = String(progress);
		}

		return functionSTArr;
	} else {
		return [];
	}
}

function initProstitutionAnimation() {
	const chartBlockEl = document.querySelector(".js-prostitution-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley wrapper
		const trolleyWrapper = chartBlockEl.closest(".trolley-big");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");

		// Trigger distance from start of the block
		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48;
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			refreshPriority: 55,
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			invalidateOnRefresh: true,
			// id: "prostitution",
			// markers: true,
			start: !helpers.isMobile() ? "top center-=100" : `top-=${pinOffset + 50} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll} center` : `top-=${pinOffset - 600} top`,
			// 	trolleyParentEl.classList.add('pin-spacer-capable')
			// },
			onEnter: () => {
			},
			onEnterBack: () => {
			},
			onLeave: () => {
				trolleyWrapper.classList.remove("trolley-custom");
			},
			onLeavBack: () => {
				trolleyWrapper.classList.remove("trolley-custom");
			},
			onToggle: ({isActive}) => {
				// if (isActive === true) {
				// 	// outter trolley-big
				// 	trolleyWrapper.classList.add('trolley-custom');
				// } else {
				// 	trolleyWrapper.classList.remove('trolley-custom');
				// }
			},
			onUpdate(e) {
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				if (helpers.isMobile()) {
					chartTextBlockEl.style.transform = `translate3d(0,-${(distanceToScroll / 1.5) * e.progress}px, 0)`;
				} else {
					chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll / 1.8) * e.progress}px, 0)`;
				}
			},
		});
		functionSTArr.push(sectionST);

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		// const chart_1 =
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_1_pointer}"]`),
		};
		chart_1.mainCircle = chart_1.chartWrapper.querySelector(".chart-circle");
		chart_1.bgCircle = chart_1.mainCircle.querySelector(".chart-circle__bg");
		chart_1.smallCircle = chart_1.mainCircle.querySelector(".chart-circle__fill");
		chart_1.text = chart_1.smallCircle.querySelector(".chart-circle__graph-text");
		chart_1.smallCircleDefaultScale = Math.sqrt(parseFloat(chart_1.smallCircle.getAttribute("data-circle-scale"), 10));

		const text1ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 54,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top center` : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${block_1.clientHeight + gapFromStartOfTheBlock * 2} bottom-=100` : `top-=${pinOffset - 300} top`,
			// markers: true,
			// id: "pt-1",
			onEnter: ({progress}) => {
				console.log("enter 21");
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: ({progress}) => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
			},
			onLeave: ({progress, direction, isActive}) => {
				block_1.classList.remove("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.add("charts-row--hidden");
			},
			onUpdate(e) {
				// paragraph_1_animation(e.progress);
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text1ST);

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		const chart_2_pointer = block_2.getAttribute("data-to-chart");
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_2_pointer}"]`), columns: [],
		};
		const chart2Columns = chart_2.chartWrapper.querySelectorAll(".charts-col");
		chart2Columns.forEach((chart2Col, index) => {
			chart_2.columns.push({
				index,
				column: chart2Col,
				textValueEl: chart2Col.querySelector(".chart-value"),
				textCaptionEl: chart2Col.querySelector(".chart-caption"),
				mainCircle: chart2Col.querySelector(".chart-circle"),
				bgCircle: chart2Col.querySelector(".chart-circle__bg"),
				smallCircle: chart2Col.querySelector(".chart-circle__fill"),
				smallCircleDefaultScale: Math.sqrt(parseFloat(chart2Col
					.querySelector(".chart-circle__fill")
					.getAttribute("data-circle-scale"), 10)),
			});
		});

		// Set initial scale 0 to bg cirlces in animation
		// chart_2.columns.forEach((column) => {
		// 	// Scale bg cirlces
		// 	column.bgCircle.style.transform = `scale3d(0, 0, 1)`;
		// });

		// Legend
		chart_2.legend = chartBlockEl.querySelector(".chart-legend_caption-col");
		chart_2.legend.style.opacity = `0`;

		// New
		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 53,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top+=${block_2.offsetTop + gapFromStartOfTheBlock * 2} bottom-=100` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock * 2} top` : `top-=${pinOffset - 600} top`,
			// markers: true,
			// id: "p-2",
			onEnter: () => {
				console.log("enter 22");
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			}, // { progress, direction, isActive }
			// onLeave: () => {
			// 	block_2.classList.remove('js-scrollanimation-text--active');
			// },
			onLeaveBack: () => {
				block_2.classList.remove("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.add("charts-row--hidden");
				// chart_2.chartWrapper.classList.remove('charts-row--hidden');
			},
			onUpdate(e) {
				paragraph_2_animation(e.progress);
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartText2.offsetHeight + 30);

					chartText2.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text2ST);

		// New

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		function paragraph_1_animation(progress) {
			// Quickly hide all other elements of the cirlce
			// Clamp value between 0 and 1
			const fastOpacity = clamp(1 - progress * 7, 0, 1); // Will return: 0
			// const fastOpacity = Math.min(Math.max((1 - progress * 7), 0), 1);

			chart_1.bgCircle.style.opacity = fastOpacity;
			chart_1.text.style.opacity = fastOpacity;

			// Lift cirlce up on half of the height
			const circleDelta = (-1 * progress * chart_1.smallCircle.clientHeight) / 2;

			// Start scaling down the object when progress is higher than 80%
			// 		p.s. we are using math formulas to avoid using if operator in order to gain performance
			const circleScale = chart_1.smallCircleDefaultScale - 0.5 * Math.abs(Math.max(progress - 0.8, 0));
			chart_1.smallCircle.style.transform = `scale3d(${circleScale}, ${circleScale}, 1) translate3d(0, ${circleDelta}px, 0)`;
		}

		// Second text block related animation
		function paragraph_2_animation(progress) {
			const number = (1 - progress) * 30;
			// const columnsArrLength = chart_2.columns.length;

			// Move legend
			chart_2.legend.style.opacity = String(progress);
		}

		return functionSTArr;
	} else {
		return [];
	}
}

function initFactory2Animation() {
	const chartBlockEl = document.querySelector(".js-factory2-animation");
	if (chartBlockEl) {
		let functionSTArr = [];

		// Trolley wrapper
		const trolleyWrapper = chartBlockEl.closest(".trolley-big");

		// Global chart block
		const chartEl = chartBlockEl.querySelector(".chart");

		// Chart area of the chart block
		const chartAreaEl = chartEl.querySelector(".chart__area");

		// Text part of the chart block | Block which hold text paragraphs's wrapper and create a structure in CSS
		const chartTextBlockWrapperEl = chartBlockEl.querySelector(".chart__descriptions-block");

		// Block with text paragraphs
		const chartTextBlockEl = chartBlockEl.querySelector(".chart__description-wrapper");

		// Last paragraph block inside text wrapper
		const lastTextPEl = chartTextBlockEl.querySelector(".js-scrollanimation-text:last-child");

		// Blocks of text to animate
		const textBlocksArr = chartTextBlockEl.querySelectorAll(".js-scrollanimation-text");

		// Trigger distance from start of the block
		const chartsElementsArr = chartEl.querySelectorAll(".charts-row");
		const chartsColumnsArr = [];
		// Collect all chart columns
		chartsElementsArr.forEach((chartElItem) => {
			chartsColumnsArr.push(...chartElItem.querySelectorAll(".charts-col"));
		});

		// Find the maximum content sum of content heights of all chart columns
		let chartElHeightsArr = [];
		chartsColumnsArr.forEach((chartColumnElItem) => {
			let sumHeight = 0;
			for (const child of chartColumnElItem.children) {
				sumHeight = Number(child.clientHeight) + Number(child.offsetTop);
			}
			chartElHeightsArr.push(sumHeight);
		});

		// Wrapper of .chart element
		const chartWrapperEl = chartBlockEl.querySelector(".chart-element");
		// Distance from start of the block to it's parent
		const gapFromStartOfTheBlock = chartWrapperEl.offsetTop;
		// Distance to scroll
		const distanceToScroll = chartTextBlockEl.clientHeight - gapFromStartOfTheBlock - 48;
		let chartText1 = chartBlockEl.querySelector('[data-chart="1"] .charts__text.for-devices');
		let chartText2 = chartBlockEl.querySelector('[data-chart="2"] .charts__text.for-devices');

		const pinOffset = document.querySelector('.header').offsetHeight;

		const sectionST = ScrollTrigger.create({
			pin: trolleyWrapper,
			refreshPriority: 52,
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			invalidateOnRefresh: true,
			// id: "factory2",
			// markers: true,
			start: !helpers.isMobile() ? `top+=${chartWrapperEl.clientHeight * 0.18} center` : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${distanceToScroll} center` : `top-=${pinOffset - 600} top`,
			// 	trolleyParentEl.classList.add('pin-spacer-capable')
			// },
			onEnter: () => {
			},
			onEnterBack: () => {
			},
			onLeave: () => {
				trolleyWrapper.classList.remove("trolley-custom");
			},
			onLeavBack: () => {
				trolleyWrapper.classList.remove("trolley-custom");
			},
			onToggle: ({isActive}) => {
			},
			onUpdate(e) {
				// scrollToTopBlock(e.progress, chartTextBlockEl);
				if (helpers.isMobile()) {
					chartTextBlockEl.style.transform = `translate3d(0, -${distanceToScroll / 1.8 * e.progress}px, 0)`;
				} else {
					chartTextBlockEl.style.transform = `translate3d(0, -${(distanceToScroll / 1.8) * e.progress}px, 0)`;
				}
			},
		});
		functionSTArr.push(sectionST);

		// Animation for the first paragraph
		const block_1 = textBlocksArr[0];
		const chart_1_pointer = block_1.getAttribute("data-to-chart");
		const chart_1 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="1"]`),
		};
		chart_1.legend = chartBlockEl.querySelector(`.chart-legend_caption-col[data-chart="${chart_1_pointer}"]`);

		const text1ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? block_1 : chartBlockEl,
			refreshPriority: 51,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top center` : `top-=${pinOffset} top`,
			end: !helpers.isMobile() ? `top+=${block_1.clientHeight + gapFromStartOfTheBlock} bottom-=200` : `top-=${pinOffset - 300} top`,
			markers: false,
			onEnter: ({progress}) => {
				console.log("enter 21");
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: ({progress}) => {
				block_1.classList.add("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.remove("charts-row--hidden");
			},
			onLeave: ({progress, direction, isActive}) => {
				block_1.classList.remove("js-scrollanimation-text--active");
				chart_1.chartWrapper.classList.add("charts-row--hidden");
			},
			onUpdate(e) {
				paragraph_1_animation(e.progress);
				if (helpers.isMobile()) {
					const progress = -e.progress * (chartBlockEl.offsetHeight + chartText1.offsetHeight);

					chartText1.style.transform = `translateY(${progress}px)`;
				}
			},
		});
		functionSTArr.push(text1ST);

		// Animation for the second paragraph
		const block_2 = textBlocksArr[1];
		const chart_2_pointer = block_2.getAttribute("data-to-chart");
		const chart_2 = {
			chartWrapper: chartBlockEl.querySelector(`.charts-row[data-chart="${chart_2_pointer}"]`), columns: [],
		};
		chart_2.legend = chartBlockEl.querySelector(`.chart-legend_caption-col[data-chart="2"]`);
		chart_2.legend.style.opacity = `0`;
		const chart2Columns = chart_2.chartWrapper.querySelectorAll(".charts-col");
		// chart2Columns.forEach((chart2Col, index) => {
		// 	chart_2.columns.push({
		// 		index,
		// 		column: chart2Col,
		// 		textValueEl: chart2Col.querySelector(".chart-value"),
		// 		textCaptionEl: chart2Col.querySelector(".chart-caption"),
		// 		mainCircle: chart2Col.querySelector(".chart-circle"),
		// 		bgCircle: chart2Col.querySelector(".chart-circle__bg"),
		// 		smallCircle: chart2Col.querySelector(".chart-circle__fill"),
		// 		smallCircleDefaultScale: Math.sqrt(parseFloat(chart2Col
		// 			.querySelector(".chart-circle__fill")
		// 			.getAttribute("data-circle-scale"), 10)),
		// 	});
		// });

		// Set initial scale 0 to bg cirlces in animation
		// chart_2.columns.forEach((column) => {
		// 	// Scale bg cirlces
		// 	column.bgCircle.style.transform = `scale3d(0, 0, 1)`;
		// });

		// New
		const text2ST = ScrollTrigger.create({
			trigger: !helpers.isMobile() ? chartTextBlockEl : chartBlockEl,
			refreshPriority: 50,
			invalidateOnRefresh: true,
			start: !helpers.isMobile() ? `top+=${block_2.offsetTop + gapFromStartOfTheBlock} bottom-=200` : `top-=${pinOffset - 300} top`,
			end: !helpers.isMobile() ? `top+=${block_2.offsetTop + block_2.clientHeight - gapFromStartOfTheBlock * 2} top` : `top-=${pinOffset - 600} top`,
			markers: false,
			id: "p-2",
			onEnter: () => {
				console.log("enter 22");
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			},
			onEnterBack: () => {
				block_2.classList.add("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.remove("charts-row--hidden");
			}, // { progress, direction, isActive }
			// onLeave: () => {
			// 	block_2.classList.remove('js-scrollanimation-text--active');
			// },
			onLeaveBack: () => {
				block_2.classList.remove("js-scrollanimation-text--active");
				chart_2.chartWrapper.classList.add("charts-row--hidden");
				// chart_2.chartWrapper.classList.remove('charts-row--hidden');
			},
			onUpdate(e) {
				console.log('e', e);
				paragraph_2_animation(e.progress);

				if (helpers.isMobile()) {
					const progress = -e.progress * (chartWrapperEl.offsetHeight + chartText2.offsetHeight + 25);

					chartText2.style.transform = `translateY(${progress}px)`;
				}

				console.log('chartText2', chartText2);
			},
		});
		functionSTArr.push(text2ST);

		// New

		/**
		 *  Utils functions
		 **/
		// First text block related animation
		function paragraph_1_animation(progress) {
			chart_1.legend.style.opacity = String(1 - progress);
		}

		// Second text block related animation
		function paragraph_2_animation(progress) {
			chart_2.legend.style.opacity = String(progress);
		}

		return functionSTArr;
	} else {
		return [];
	}
}

function initChartsAnimation() {
	let sumSTArr = [];

	/**
	 *  Chapter 1 charts ->
	 **/
		//
		// js-enterpreneurs-animation
	const enterpreneurSTArr = initEnterpreneursAnimation();
	sumSTArr.push(...enterpreneurSTArr);

	// js-nurses-animation
	const nursesSTArr = initNursesAnimation();
	sumSTArr.push(...nursesSTArr);

	// js-capable-animation
	const capableASTArr = initCapableAnimation();
	sumSTArr.push(...capableASTArr);

	// telegraph chart.js
	const telegraphSTArr = initTelegraphAnimation();
	sumSTArr.push(...telegraphSTArr);

	// js-factory-animation
	const factorySTArr = initFactoryAnimation();
	sumSTArr.push(...factorySTArr);
	/**
	 *  Chapter 1 charts <-
	 **/

	/**
	 *  Chapter 2 charts ->
	 **/
		// js-universities-animation
	const universitiesSTArr = initUniversitiesAnimation();
	sumSTArr.push(...universitiesSTArr);

	// js-schools-animation
	const schoolsSTArr = initSchoolsAnimation();
	sumSTArr.push(...schoolsSTArr);

	const schoolsSTArra = initProcessAnimation();
	sumSTArr.push(...schoolsSTArra);
	const schoolsSTArra2 = initProcess2Animation();
	sumSTArr.push(...schoolsSTArra2);

	// js-zurich-students-animation
	const zurichStudentsSTArr = initZurichStudentsAnimation();
	sumSTArr.push(...zurichStudentsSTArr);

	// js-zurich-students-animation
	const massProtestsSTArr = initMassProtestsAnimation();
	sumSTArr.push(...massProtestsSTArr);

	// js-doctors-chart
	const doctorsSTArr = initDoctorsAnimation();
	sumSTArr.push(...doctorsSTArr);

	// js-spheres-animation
	const spheresSTArr = initSpheresAnimation();
	sumSTArr.push(...spheresSTArr);
	/**
	 *  Chapter 2 charts <-
	 **/

	/**
	 *  Chapter 4 charts ->
	 **/
		//
		// js-prostitution-animation
	const prostitutionSTArr = initProstitutionAnimation();
	sumSTArr.push(...prostitutionSTArr);

	const factory2STArr = initFactory2Animation();
	sumSTArr.push(...factory2STArr);
	/**
	 *  Chapter 4 charts <-
	 **/

	return sumSTArr;
}

const init = () => {
	// Array of scrolltriggers to update
	let stToRefresh = [];

	/**
	 *  THREE JS PART
	 **/
	// Setting up scene and all animations
	/**
	 *  Import shaders
	 **/
	const vertexShader = vertexShaderFile.init();
	const fragmentShader = fragmentShaderFile.init();

	/**
	 * Sizes
	 */
	const canvasWrapper = document.querySelector(".animation-effect-wrapper .animation-effect");
	const sizes = {
		width: canvasWrapper.clientWidth, // width: window.innerWidth,
		height: window.innerHeight,
	};

	function setSizes() {
		sizes.width = canvasWrapper.clientWidth;
		sizes.height = window.innerHeight;

		console.log(sizes.width / sizes.height)
	}

	/**
	 * Base
	 */
		// Canvas
	const canvas = document.querySelector("canvas.webgl");

	// Scene
	const scene = new THREE.Scene();

	// const cameraSizeVisibleDistance = 0.1;
	/**
	 * Camera
	 */
		// OrthographicCamera
	let aspectRatio = sizes.width / sizes.height;
	const CAMERA_FRUSTRUM = 0.6;
	const CAMERA_NEAR = 0.1;
	const CAMERA_FAR = 2;
	console.log(aspectRatio)
	const camera = new THREE.OrthographicCamera(-CAMERA_FRUSTRUM * aspectRatio, // left
		CAMERA_FRUSTRUM * aspectRatio, // right
		CAMERA_FRUSTRUM, // top
		-CAMERA_FRUSTRUM, // bottom
		CAMERA_NEAR, // near
		CAMERA_FAR // far
	);
	camera.position.z = 1;



	if (helpers.isMobile()) {
		camera.zoom = 0.69;
		camera.updateProjectionMatrix();

		if(helpers.$html.hasClass('is-device-tablet')) {

		}
	}

	let isiPad = navigator.userAgent.toLowerCase().indexOf("ipad");

	if (isiPad > -1) {
		console.log('ipad')
		if(window.innerHeight > window.innerWidth){
			camera.zoom = 1;
			camera.updateProjectionMatrix();
		} else {
			camera.zoom = 0.69;
			camera.updateProjectionMatrix();
		}
	}

	if (window.innerWidth > 3000) {
		camera.zoom = 0.9;
		camera.updateProjectionMatrix();
	}

	/**
	 * Bubble Object
	 */
		// Custom geometry
	const systemColors = {
			dark: [31, 10, 49], purple: [169, 70, 255], gray: [225, 216, 216], orange: [255, 70, 70],
		};


	// systemParameters.VERTICES_AMOUNT - amount of points
	const systemParameters = {
		VERTICES_AMOUNT: 2000, RADIUS: 0.5,
	};

	// Array with points position
	const pointsCoordVec3Arr = [];
	const pointsCoordVec3ArrLast = [];
	const pointsCoordVec3ArrOrange = [];
	let black = true;
	const pointsColorVec3Arr = [];
	const pointsColorVec3ArrLast = [];
	const pointsColorVec3ArrOrange = [];
	let systemGeometry = null;
	let systemGeometryLast = null;
	let systemGeometryOrange = null;
	// Array with points colors

	const colorsArr = new Float32Array(pointsColorVec3Arr);

	const colorsArrLast = new Float32Array(pointsColorVec3ArrLast);

	const colorsArrOrange = new Float32Array(pointsColorVec3ArrLast);
	/**
	 *  Set individual amplitude and direction to each vertex
	 **/
		// Array of position of vertexes
		// Since each vertex will have amplitude and direction
		// First parameter = max amplitude on X
		// Second parameter = max amplitude on Y
	const vertexDistortionAmplitude = new Float32Array(systemParameters.VERTICES_AMOUNT * 2);

	for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
		const i2 = i * 2;

		let vertexAmplitudeX = 3.5;
		let vertexAmplitudeY = 3.5;
		if (i % 45 == 0) {
			vertexAmplitudeX = Math.max(Math.random() * 7.0, 5.0);
			vertexAmplitudeY = Math.max(Math.random() * 7.0, 5.0);
		} else if (i % 30 == 0) {
			vertexAmplitudeX = Math.max(Math.random() * 6.0, 4.5);
			vertexAmplitudeY = Math.max(Math.random() * 6.0, 4.5);
		} else if (i % 20 == 0) {
			vertexAmplitudeX = Math.max(Math.random() * 5.0, 4.0);
			vertexAmplitudeY = Math.max(Math.random() * 5.0, 4.0);
		} else if (i % 10 == 0) {
			vertexAmplitudeX = Math.max(Math.random() * 4.25, 3.5);
			vertexAmplitudeY = Math.max(Math.random() * 4.25, 3.5);
		} else {
			vertexAmplitudeX = Math.max(Math.random() * 3.5, 3.0);
			vertexAmplitudeY = Math.max(Math.random() * 3.5, 3.0);
		}

		vertexDistortionAmplitude[i2] = (Math.random() - 0.5) * vertexAmplitudeX * Math.random();
		vertexDistortionAmplitude[i2 + 1] = (Math.random() - 0.5) * vertexAmplitudeY * Math.random();
	}

	const particle = {
		size: 5,
	};

	// Simulate GSAP
	const gsapScrollTrigger = {
		value: 0,
	};

	// Simulate person effect starter
	const personEffect = {
		radius: 0.3, progress: 0.0,
	};

	// Simulate "two camps" effect starter
	const twoCampsEffect = {
		curve: 1.0, curve_b: 1.0, margin: 0.05, progress: 0.0, radius: 0.33, colorProgress: 0,
	};

	const korsini = {
		curve: 1.0, curve_b: 1.0, margin: 0.05, progress: 0.0, radius: 0.33, colorProgress: 0,
	};

	const revo = {
		curve: 1.0, curve_b: 1.0, margin: 0.05, progress: 0.0, radius: 0.33, colorProgress: 0,
	};

	console.log(particle.size, 'size particle')

	const objectMaterial = new THREE.ShaderMaterial({
		depthWrite: false,
		vertexColors: true,
		vertexShader: vertexShader,
		fragmentShader: fragmentShader, // alphaTest: true,
		transparent: true,
		uniforms: {
			uParticleSize: {value: particle.size},
			uResolution: {
				value: new THREE.Vector2(sizes.width, window.innerHeight),
			},
			uTime: {value: 0},
			uInitialProgress: {value: gsapScrollTrigger.value}, // Will go from 0 to 1
			uDistancingRadius: {value: personEffect.radius},
			uPersonEffectProgress: {value: personEffect.progress},
			uShapeCircleLimit: {value: twoCampsEffect.radius},
			uTwoCampsProgress: {value: twoCampsEffect.progress}, // Two camps progress
			korsini: {value: korsini.progress}, // korsini progress
			uTwoCampsColorProgress: {value: twoCampsEffect.colorProgress}, // Two camps progress
			korsiniColorProgress: {value: korsini.colorProgress}, // korsini progress
			revoColorProgress: {value: revo.colorProgress}, // revo progress
			uIsDividingColors: {value: 0}, // If we change colors on "green" and "red" in "two camps" effect
			uIsDividingColorsKorsini: {value: 0}, // If we change colors on "green" and "red" in "two camps" effect
			uIsDividingColorsRevo: {value: 0}, // If we change colors on "green" and "red" in "revo" effect
		}, // On production put a values from uniform here!
		defines: {
			// uParticleSize: particle.size,
			// uParticleAttunuation: 15.0,
		}, // size: 4,
		// sizeAttenuation: false,
		// color: new THREE.Color('black'),
	});
	const generateSystemLast = () => {
		const objectGeometry = new THREE.BufferGeometry();

		/**
		 *  Create points in random coordinates
		 **/
		for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
			// Create random radius
			const randomR = systemParameters.RADIUS * Math.sqrt(Math.random());
			// Create random angle
			const theta = Math.random() * 2 * Math.PI;

			// Set coordinates with a random radius and a random angle
			const x_coord = randomR * Math.sin(theta);
			const y_coord = randomR * Math.cos(theta);

			const pointCoord = [x_coord, y_coord, 0];

			pointsCoordVec3ArrLast.push(...pointCoord);

			// Set color to a point
			// Set only to 10% of the points
			if (i % 20 == 0) {
				// Then point will be purple
				const pointColor = systemColors.purple;
				pointsColorVec3ArrLast.push(...pointColor);
			} else {
				// Point will be dark
				const pointColor = systemColors.gray;
				pointsColorVec3ArrLast.push(...pointColor);
			}
		}

		// Convert our array with positions to typed array
		const positionsArr = new Float32Array(pointsCoordVec3ArrLast);

		// Convert colors array to typed array
		const colorsArrLast = new Float32Array(pointsColorVec3ArrLast);

		// Simulate UV coordinates
		const uvArr = new Float32Array(pointsCoordVec3ArrLast);
		for (let i = 0; i < uvArr.length; i++) {
			uvArr[i] += 0.5; // Since we are considering it goes from [0 -> 1] while on actual canvas it positioned [-0.5 -> 0.5]
		}

		// Set individual (start) distortion on X and Y
		const aVertexAmplitudeX = new Float32Array(systemParameters.VERTICES_AMOUNT);
		for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
			aVertexAmplitudeX[i] = Math.max(Math.random() * 5, 0.5);
		}
		const aVertexAmplitudeY = new Float32Array(systemParameters.VERTICES_AMOUNT);
		for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
			aVertexAmplitudeY[i] = Math.max(Math.random() * 5, 0.5);
		}

		// Set random value
		const aRandomValueArr = new Float32Array(systemParameters.VERTICES_AMOUNT);
		for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
			aRandomValueArr[i] = Math.random();
		}

		// Set position to every vertex
		objectGeometry.setAttribute("position", new THREE.BufferAttribute(positionsArr, 3)); // Create attribute and set that every position has 3 values

		// Set color to every vertex
		objectGeometry.setAttribute("aColor", new THREE.BufferAttribute(colorsArrLast, 3)); // Create attribute and set that every position has 3 values
		// Set emulation of UV
		objectGeometry.setAttribute("aUv", new THREE.BufferAttribute(uvArr, 3)); // Create attribute and set that every position has 3 values

		// Set vertex initial distortion on X
		objectGeometry.setAttribute("aDistortionAmplitudeX", new THREE.BufferAttribute(aVertexAmplitudeX, 1)); // Create attribute and set that every position has 1 value
		// Set vertex initial distortion on Y
		objectGeometry.setAttribute("aDistortionAmplitudeY", new THREE.BufferAttribute(aVertexAmplitudeY, 1)); // Create attribute and set that every position has 1 value

		// Set random value (to randomise vertexes movements)
		objectGeometry.setAttribute("aRandomValue", new THREE.BufferAttribute(aRandomValueArr, 1)); // Create attribute and set that every position has 1 value

		return objectGeometry;
	};
	systemGeometryLast = generateSystemLast();

	// systemGeometryLast.setAttribute("aColor", new THREE.BufferAttribute(colorsArrLast, 3)); // Create attribute and set that every position has 3 values
	systemGeometryLast.setAttribute("aVertexDistortion", new THREE.BufferAttribute(vertexDistortionAmplitude, 2));
	let objectMesh2 = new THREE.Points(systemGeometryLast, objectMaterial);
	objectMesh2.matrixAutoUpdate = false; // Since mesh itself is static
	helpers.$document.on('particle-color-white', () => {
		korsiniPicture.classList.add('is-hidden');
		console.log(black)
		if (black) {
			korsiniPicture.classList.remove('is-hidden');

			const n = scene.children.length - 1;
			for (var i = n; i > -1; i--) {
				scene.remove(scene.children[i]);
			}

			scene.add(objectMesh2);
			systemGeometryLast.setAttribute("aColor", new THREE.BufferAttribute(new Float32Array(pointsColorVec3ArrLast), 3));

			black = false;
		}
	});
	const generateSystem = () => {
		const objectGeometry = new THREE.BufferGeometry();

		/**
		 *  Create points in random coordinates
		 **/
		for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
			// Create random radius
			const randomR = systemParameters.RADIUS * Math.sqrt(Math.random());
			// Create random angle
			const theta = Math.random() * 2 * Math.PI;

			// Set coordinates with a random radius and a random angle
			const x_coord = randomR * Math.sin(theta);
			const y_coord = randomR * Math.cos(theta);

			const pointCoord = [x_coord, y_coord, 0];

			pointsCoordVec3Arr.push(...pointCoord);

			// Set color to a point
			// Set only to 10% of the points
			if (i % 30 == 0) {
				// Then point will be purple
				const pointColor = systemColors.purple;
				pointsColorVec3Arr.push(...pointColor);
			} else {
				// Point will be dark
				const pointColor = systemColors.dark;
				pointsColorVec3Arr.push(...pointColor);
			}
		}

		// Convert our array with positions to typed array
		const positionsArr = new Float32Array(pointsCoordVec3Arr);

		// Convert colors array to typed array
		const colorsArr = new Float32Array(pointsColorVec3Arr);

		// Simulate UV coordinates
		const uvArr = new Float32Array(pointsCoordVec3Arr);
		for (let i = 0; i < uvArr.length; i++) {
			uvArr[i] += 0.5; // Since we are considering it goes from [0 -> 1] while on actual canvas it positioned [-0.5 -> 0.5]
		}

		// Set individual (start) distortion on X and Y
		const aVertexAmplitudeX = new Float32Array(systemParameters.VERTICES_AMOUNT);
		for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
			aVertexAmplitudeX[i] = Math.max(Math.random() * 5, 0.5);
		}
		const aVertexAmplitudeY = new Float32Array(systemParameters.VERTICES_AMOUNT);
		for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
			aVertexAmplitudeY[i] = Math.max(Math.random() * 5, 0.5);
		}

		// Set random value
		const aRandomValueArr = new Float32Array(systemParameters.VERTICES_AMOUNT);
		for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
			aRandomValueArr[i] = Math.random();
		}

		// Set position to every vertex
		objectGeometry.setAttribute("position", new THREE.BufferAttribute(positionsArr, 3)); // Create attribute and set that every position has 3 values

		// Set color to every vertex
		objectGeometry.setAttribute("aColor", new THREE.BufferAttribute(colorsArr, 3)); // Create attribute and set that every position has 3 values
		// Set emulation of UV
		objectGeometry.setAttribute("aUv", new THREE.BufferAttribute(uvArr, 3)); // Create attribute and set that every position has 3 values

		// Set vertex initial distortion on X
		objectGeometry.setAttribute("aDistortionAmplitudeX", new THREE.BufferAttribute(aVertexAmplitudeX, 1)); // Create attribute and set that every position has 1 value
		// Set vertex initial distortion on Y
		objectGeometry.setAttribute("aDistortionAmplitudeY", new THREE.BufferAttribute(aVertexAmplitudeY, 1)); // Create attribute and set that every position has 1 value

		// Set random value (to randomise vertexes movements)
		objectGeometry.setAttribute("aRandomValue", new THREE.BufferAttribute(aRandomValueArr, 1)); // Create attribute and set that every position has 1 value

		return objectGeometry;
	};


	systemGeometry = generateSystem();

	// systemGeometry.setAttribute("aColor", new THREE.BufferAttribute(colorsArr, 3)); // Create attribute and set that every position has 3 values
	// Set vertex's individual parameters to geometry
	systemGeometry.setAttribute("aVertexDistortion", new THREE.BufferAttribute(vertexDistortionAmplitude, 2));

	let objectMesh = new THREE.Points(systemGeometry, objectMaterial);
	objectMesh.matrixAutoUpdate = false; // Since mesh itself is static
	// NOTE! DISABLE UPDATE ON PRODUCTION SINCE IT'S A STATIC MESH
	const n = scene.children.length - 1;
	for (var i = n; i > -1; i--) {
		scene.remove(scene.children[i]);
	}
	scene.add(objectMesh);
	helpers.$document.on('particle-color-black', () => {
		if (!black) {
			console.log(black)

			// const n = scene.children.length - 1;
			// for (var i = n; i > -1; i--) {
			// 	scene.remove(scene.children[i]);
			// }
			// scene.add(objectMesh);
			systemGeometryLast.setAttribute("aColor", new THREE.BufferAttribute(new Float32Array(pointsColorVec3Arr), 3));

			black = true;
		}
	});

	const generateSystemOrange = () => {
		const objectGeometry = new THREE.BufferGeometry();

		/**
		 *  Create points in random coordinates
		 **/
		for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
			// Create random radius
			const randomR = systemParameters.RADIUS * Math.sqrt(Math.random());
			// Create random angle
			const theta = Math.random() * 2 * Math.PI;

			// Set coordinates with a random radius and a random angle
			const x_coord = randomR * Math.sin(theta);
			const y_coord = randomR * Math.cos(theta);

			const pointCoord = [x_coord, y_coord, 0];

			pointsCoordVec3ArrOrange.push(...pointCoord);

			// Set color to a point
			// Set only to 10% of the points
			if (i % 20 == 0) {
				// Then point will be purple
				const pointColor = systemColors.orange;
				pointsColorVec3ArrOrange.push(...pointColor);
			} else {
				// Point will be dark
				const pointColor = systemColors.orange;
				pointsColorVec3ArrOrange.push(...pointColor);
			}
		}

		// Convert our array with positions to typed array
		const positionsArr = new Float32Array(pointsCoordVec3ArrOrange);

		// Convert colors array to typed array
		const colorsArrOrange = new Float32Array(pointsColorVec3ArrOrange);

		// Simulate UV coordinates
		const uvArr = new Float32Array(pointsCoordVec3ArrOrange);
		for (let i = 0; i < uvArr.length; i++) {
			uvArr[i] += 0.5; // Since we are considering it goes from [0 -> 1] while on actual canvas it positioned [-0.5 -> 0.5]
		}

		// Set individual (start) distortion on X and Y
		const aVertexAmplitudeX = new Float32Array(systemParameters.VERTICES_AMOUNT);
		for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
			aVertexAmplitudeX[i] = Math.max(Math.random() * 5, 0.5);
		}
		const aVertexAmplitudeY = new Float32Array(systemParameters.VERTICES_AMOUNT);
		for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
			aVertexAmplitudeY[i] = Math.max(Math.random() * 5, 0.5);
		}

		// Set random value
		const aRandomValueArr = new Float32Array(systemParameters.VERTICES_AMOUNT);
		for (let i = 0; i < systemParameters.VERTICES_AMOUNT; i++) {
			aRandomValueArr[i] = Math.random();
		}

		// Set position to every vertex
		objectGeometry.setAttribute("position", new THREE.BufferAttribute(positionsArr, 3)); // Create attribute and set that every position has 3 values

		// Set color to every vertex
		objectGeometry.setAttribute("aColor", new THREE.BufferAttribute(colorsArrOrange, 3)); // Create attribute and set that every position has 3 values
		// Set emulation of UV
		objectGeometry.setAttribute("aUv", new THREE.BufferAttribute(uvArr, 3)); // Create attribute and set that every position has 3 values

		// Set vertex initial distortion on X
		objectGeometry.setAttribute("aDistortionAmplitudeX", new THREE.BufferAttribute(aVertexAmplitudeX, 1)); // Create attribute and set that every position has 1 value
		// Set vertex initial distortion on Y
		objectGeometry.setAttribute("aDistortionAmplitudeY", new THREE.BufferAttribute(aVertexAmplitudeY, 1)); // Create attribute and set that every position has 1 value

		// Set random value (to randomise vertexes movements)
		objectGeometry.setAttribute("aRandomValue", new THREE.BufferAttribute(aRandomValueArr, 1)); // Create attribute and set that every position has 1 value

		return objectGeometry;
	};

	systemGeometryOrange = generateSystemOrange();

	// systemGeometryLast.setAttribute("aColor", new THREE.BufferAttribute(colorsArrLast, 3)); // Create attribute and set that every position has 3 values
	systemGeometryLast.setAttribute("aVertexDistortion", new THREE.BufferAttribute(vertexDistortionAmplitude, 2));
	let objectMeshOrange = new THREE.Points(systemGeometryOrange, objectMaterial);
	objectMeshOrange.matrixAutoUpdate = false; // Since mesh itself is static

	helpers.$document.on('particle-color-orange', () => {

		if (black) {

			// const n = scene.children.length - 1;

			// systemGeometry.morphAttributes.aColor = new THREE.BufferAttribute(new Float32Array(pointsColorVec3ArrOrange), 3);
			systemGeometryLast.setAttribute("aColor", new THREE.BufferAttribute(new Float32Array(pointsColorVec3ArrOrange), 3));
			// for (var i = n; i > -1; i--) {
			// 	scene.remove(scene.children[i]);
			// }

			// scene.add(objectMeshOrange);

			black = false;
		}
	});
	// helpers.$document.on('particle-color-white', () => {
	// 	korsiniPicture.classList.add('is-hidden');
	//
	// });
	//
	// helpers.$document.on('particle-color-black', () => {
	// 	korsiniPicture.classList.add('is-hidden');
	//
	// });

	const CAMERA_PARAMETERS = {
		CAMERA_FRUSTRUM: CAMERA_FRUSTRUM,
	};

	scene.add(camera);

	/**
	 *  Handle resize
	 **/
	let clientWidth = document.body.clientWidth;
	window.addEventListener("resize", debounce(function (event) {
		const currentWidth = document.body.clientWidth;

		// Update render
		if (currentWidth !== clientWidth) {
			// Execure high frequency effect
			// Update sizes
			setSizes();

			// Update camera aspect ratio
			aspectRatio = sizes.width / sizes.height;
			camera.left = -CAMERA_FRUSTRUM * aspectRatio;
			camera.right = CAMERA_FRUSTRUM * aspectRatio;
			// When change camera's properties then update projectionMatrix
			camera.updateProjectionMatrix();

			// Update resolution uniform of the material (it will be accesible from every thread of the GPU)
			objectMaterial.uniforms.uResolution.value = new THREE.Vector2(sizes.width, window.innerHeight);
			setstylePersone(sizes);
			renderer.setSize(sizes.width, sizes.height);
			renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
		}
	}, 100));

	/**
	 * Renderer
	 */
	const renderer = new THREE.WebGLRenderer({
		canvas: canvas, alpha: true, stencil: false, // We don't need it thus we disable it to win the performance
		// powerPreference: "high-performance", // Activate it to win the performance
		// depth: false, // In case of bugs try to disable it - handle on a build (We don't need it thus we disable it to win the performance)
		// precision: "mediump", // In case of bugs try to disable it - handle on a build (We don't need it thus we disable it to win the performance)
	});


	// setTimeout(() => {
	// 	setstylePersone(sizes.height);
	// }, 2000);
	window.addEventListener('load', () => {
		setstylePersone(sizes);
		// setTimeout(() => {
		// 	// fixedSection();
		// }, 2000);
	})
	// console.log(sizes.height, 'sizes.height');
	// setstylePersone(sizes.height);
	renderer.setSize(sizes.width, sizes.height);
	renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));


	/**
	 * Animate
	 */


	const clock = new THREE.Clock();

	const tick = () => {
		const elapsedTime = clock.getElapsedTime();

		// Send time value to the uniform (to the shader)
		objectMaterial.uniforms.uTime.value = elapsedTime;
		// objectMaterial.uniforms.diffuse.value.setHex ( 0xFF0000 );
		// Render
		renderer.render(scene, camera);

		// Call tick again on the next frame
		window.requestAnimationFrame(tick);
	};

	tick();

	/**
	 *  GSAP | ScrollTrigger animaiton
	 **/
		// Create timeline for initial animation
	const initialAnimationEl = document.querySelector(".js-animation-effect-initial");
	let startOffset = 0;
	if (initialAnimationEl) {
		const initialTriggerWrapperEl = initialAnimationEl.closest(".section_1");

		startOffset = parseInt($(initialTriggerWrapperEl).css("padding-top"), 10);
	}

	// Select bubbles items
	// const animationGlobalWrapperEl = document.querySelector('.animation-effect');
	const personsWrapperEl = document.querySelector(".persons-circles");
	let personsBubbles = null;
	let personsBubblesObjects = [];

	// Distance from bubbles wrapper box to it's parent
	let distanceOnX = personsWrapperEl.offsetLeft;
	let distanceOnY = personsWrapperEl.offsetTop;

	if (personsWrapperEl) {
		personsBubbles = personsWrapperEl.querySelectorAll(".person-circle");

		initPersons();
	}

	// Create person class
	function Person(initialScale, nodeEl) {
		this.initialScale = Number(initialScale);
		this.deltaX = 0;
		this.deltaY = 0;
		this.node = nodeEl;
		this.parent = this.node.closest(".persons-circles");
		this.parentWidth = this.parent.clientWidth;
		this.parentHeight = this.parent.clientHeight;

		this.init = function () {
			// Calculate the position

			const limitX = this.parentWidth / 2;
			const limitY = this.parentHeight / 2;

			// $(this.node).css('padding-top')

			// Set parameters manually. Later calculate automatically
			if (this.node.classList.contains("person-1")) {
				this.deltaX = -personsWrapperEl.offsetLeft;
				this.deltaY = -200;
			} else if (this.node.classList.contains("person-2")) {
				this.deltaX = -personsWrapperEl.offsetLeft;
				this.deltaY = sizes.height / 2;
			} else if (this.node.classList.contains("person-3")) {
				this.deltaX = personsWrapperEl.offsetLeft;
				this.deltaY = -sizes.height / 2;
			} else if (this.node.classList.contains("person-4")) {
				this.deltaX = personsWrapperEl.offsetLeft;
				this.deltaY = -200;
			} else if (this.node.classList.contains("person-5")) {
				this.deltaX = -personsWrapperEl.offsetLeft;
				this.deltaY = sizes.height / 2;
			} else if (this.node.classList.contains("person-6")) {
				this.deltaX = personsWrapperEl.offsetLeft;
				this.deltaY = sizes.height / 2;
			}

			this.node.style.transform = `scale3d(${this.initialScale}%, ${this.initialScale}%, 1) translate3d(${this.deltaX}px, ${this.deltaY}px, 0)`;
		};

		this.init();
	}

	// Move persons bubbles (since it's an HTML elements)
	function moveBubbles(progress) {
		personsBubblesObjects.forEach((bubble) => {
			// Scale to this value (in percentage)
			const scaleValue = 100 + (bubble.initialScale - 100) * (1 - progress);

			bubble.node.style.transform = `scale3d(${scaleValue}%, ${scaleValue}%, 1) translate3d(${bubble.deltaX * (1 - progress)}px, ${bubble.deltaY * (1 - progress)}px, 0)`;
		});
	}

	// Init persons bubbles animation
	function initPersons() {
		personsBubbles.forEach((bubble) => {
			const initialScaleOfTheBubble = parseInt(bubble.getAttribute("data-element-scale"), 10);

			personsBubblesObjects.push(new Person(initialScaleOfTheBubble, bubble));
			// personsBubblesObjects.push(new Person(initialScaleOfTheBubble, bubble));
		});
	}

	const initialST = ScrollTrigger.create({
		trigger: initialAnimationEl, // Position higher on "startOffset" value from top of the trigger hits center from center of the viewport
		start: `top+=${-startOffset} center`, end: "85%", // end: "100%",
		refreshPriority: 100, invalidateOnRefresh: true, id: `initial`, scrub: true, markers: false, onUpdate(e) {
			objectMaterial.uniforms.uInitialProgress.value = e.progress;

			if (window.innerWidth < 400) {
				return;
			}

			// Move persons bubbles
			moveBubbles(e.progress);
		}, onLeave: () => {
			if (window.innerWidth < 400) {
				return;
			}

			if (personsBubbles) {
				personsBubbles.forEach((bubble) => {
					bubble.classList.add("person-circle--hidden");
					// bubble.style.transform = `translate3d(0, 0, 0) scale3d(${}, ${}, 1)`;
				});
			}
		}, onEnterBack: () => {
			if (window.innerWidth < 400) {
				return;
			}

			if (personsBubbles) {
				personsBubbles.forEach((bubble) => {
					bubble.classList.remove("person-circle--hidden");
				});
			}
		},
	});
	stToRefresh.push(initialST);

	/**
	 *  Person effect
	 **/
		//
	const personPicEl = document.querySelector(".person-effect__img");
	const personEffectResetTriggerEl = document.querySelector(".js-reset-person-effect.js-pirogov");
	const personEffectGap = 40; // in px
	if (helpers.isMobile()) {
		personPicEl.style.transform = `translateX(-50%) scale3d(0%, 0%, 1)`;
	}
	// Particles effect
	const personST = ScrollTrigger.create({
		trigger: ".js-person-effect", refreshPriority: 99, scrub: true, start: `top+=${personEffectGap} top`, // start: `top+=40px top`,
		end: "+=70%", // end: `+=${2*window.innerHeight}`, // same as beyond
		pin: true, id: "person", pinSpacing: true, markers: false, invalidateOnRefresh: true, onUpdate(e) {
			objectMaterial.uniforms.uPersonEffectProgress.value = e.progress;

			if (helpers.isMobile()) {
				personPicEl.style.transform = `translateX(-50%) scale3d(${100 * e.progress}%, ${100 * e.progress}%, 1)`;
			} else {
				personPicEl.style.transform = `translate(-50%, -50%) scale3d(${100 * e.progress}%, ${100 * e.progress}%, 1)`;
			}

		}, onLeave: () => {
			personPicEl.classList.add("hidden-pirogov");
		}, onEnterBack: () => {
			personPicEl.classList.remove("hidden-pirogov");
		},
	});
	stToRefresh.push(personST);

	// Person moving photo effect | Pirogov ->
	const movingPirogovPictureTrigger = document.querySelector(".js-pirogov .js-person-gapper");
	movingPirogovPictureTrigger.classList.add("hidden-pirogov");

	// Quote Container (parent el.)
	const pirogovQuoteContainer = movingPirogovPictureTrigger.closest(".quote-standart.js-moving-photo-effect");

	// Fixed photo
	const fixedPirogovPicWrapper = document.querySelector(".person-effect__img");

	// Moving photo
	const movingPirogovPicture = movingPirogovPictureTrigger.querySelector(".person__pic");
	movingPirogovPicture.classList.add("person__pic--animated");

	// Set offset left = "half width of the container" - "half width of the block"

	if (!helpers.isMobile()) {
		movingPirogovPicture.style.left = `${Math.round((pirogovQuoteContainer.clientWidth - movingPirogovPicture.clientWidth) / 2)}px`;
	}

	// Calculate initial photos offset
	const initialPirogovOffset = window.innerHeight / 2 + movingPirogovPicture.clientHeight;

	movingPirogovPictureTrigger.style.height = `${initialPirogovOffset}px`;
	movingPirogovPictureTrigger.style.top = `-${initialPirogovOffset}px`;

	const animationBlock = pirogovQuoteContainer.closest(".container").querySelector('.animation-block.js-person-effect');
	window.addEventListener('load', () => {
		setTimeout(() => {
			const positionTopScrollTrigger = document.querySelector('.webgl').clientHeight;
			// const positionTopScrollTrigger = 548;

			console.log(positionTopScrollTrigger, 'CANVAS');

			// ScrollTrigger for moving photo of Pirogov
			const personMovingPicST = ScrollTrigger.create({
				trigger: pirogovQuoteContainer,
				refreshPriority: 98,
				// start: (self) => self.previous().end,
				start: 'bottom, bottom',
				end: helpers.isMobile() ? `start-=${positionTopScrollTrigger / 2 - movingPirogovPicture.clientHeight / 2.5 + 6}` : `start-=${window.innerHeight / 2 - movingPirogovPicture.clientHeight / 2.5}`, // end: `center center`,
				id: "pirogov",
				markers: false,
				scrub: true,
				invalidateOnRefresh: true,
				onEnter: () => {
					fixedPirogovPicWrapper.classList.add("hidden-pirogov"); // fixed pic
					movingPirogovPicture.classList.add("person__pic--animated"); // Animated picture
					movingPirogovPictureTrigger.classList.remove("hidden-pirogov");
				},
				onEnterBack: () => {
					movingPirogovPicture.classList.add("person__pic--animated"); // Animated picture
				},
				onLeaveBack: () => {
					fixedPirogovPicWrapper.classList.remove("hidden-pirogov"); // fixed pic
					movingPirogovPicture.classList.add("person__pic--animated"); // Animated picture
					movingPirogovPictureTrigger.classList.add("hidden-pirogov");
				},
				onLeave: () => {
					movingPirogovPicture.classList.remove("person__pic--animated"); // Animated picture
				},
				onUpdate(e) {
					objectMaterial.uniforms.uPersonEffectProgress.value = 1 - e.progress;

					// personPicEl.style.transform = `translate(-50%, -50%) scale3d(${100 * e.progress}%, ${100 * e.progress}%, 1)`;
				},
			});
			stToRefresh.push(personMovingPicST);

			const personResetST = ScrollTrigger.create({
				trigger: personEffectResetTriggerEl,
				refreshPriority: 97,
				start: "top top",
				end: "bottom bottom",
				id: "reset-pirogov",
				markers: false,
				invalidateOnRefresh: true,
				onLeave: () => {
					// personPicEl.classList.add('hidden');

					objectMaterial.uniforms.uPersonEffectProgress.value = 0;
				},
				onEnterBack: () => {
					// personPicEl.classList.remove('hidden');

					objectMaterial.uniforms.uPersonEffectProgress.value = 100;
				},
			});
			stToRefresh.push(personResetST);
		}, 0);
	});

	/**
	 *  Two camps effect
	 **/
		// Trigger for particles
		// ST for moving particles
	const twoCampsParticlesTrigger = document.querySelector(".js-two-camps-particles");
	const twoCampsParticlesST = ScrollTrigger.create({
		trigger: twoCampsParticlesTrigger,
		refreshPriority: 96,
		start: "top top",
		end: `top+=${Math.round(window.innerHeight / 2)} top`,
		id: "shape",
		markers: false,
		pin: true,
		invalidateOnRefresh: true,
		onUpdate(e) {
			objectMaterial.uniforms.uTwoCampsProgress.value = e.progress;
			objectMaterial.uniforms.uIsDividingColors.value = 1.0;
		},
		onLeave: () => {
			objectMaterial.uniforms.uIsDividingColors.value = 1.0;
		},
		onEnter: () => {
			objectMaterial.uniforms.uIsDividingColors.value = 1.0;
		},
		onEnterBack: () => {
			objectMaterial.uniforms.uIsDividingColors.value = 1.0;
		},
	});


	stToRefresh.push(twoCampsParticlesST);

	// Trigger for photos
	const twoCampsAnimationTrigger = document.querySelector(".js-two-camps-effect");

	// Trigger to deshape particles
	const twoCampsEffectResetTriggerEl = document.querySelector(".js-reset-two-camps-effect");

	const twoCampsPicsArray = document.querySelectorAll(".animation-effect .two-camps__pic");

	// Timeline for appearing photos
	const twoCampsAnimationTimeline = gsap.timeline({
		scrollTrigger: {
			trigger: twoCampsAnimationTrigger, refreshPriority: 95, scrub: true, start: "top-=35% top", end: "+=50%", // id: 'camps',
			pin: true, // markers: false,
			pinSpacing: true,
		},
	});

	// Effect of the appearing photos
	if (!helpers.isMobile()) {
		twoCampsAnimationTimeline
			.from(".animation-effect .two-camps__pic.two-camps__pic-1", {
				// duration: 0.5,
				scale: 0,
			})
			.from(".animation-effect .two-camps__pic.two-camps__pic-4", {
				// duration: 0.5,
				scale: 0,
			})
			.from(".animation-effect .two-camps__pic.two-camps__pic-2", {
				// duration: 0.5,
				scale: 0,
			})
			.from(".animation-effect .two-camps__pic.two-camps__pic-3", {
				// duration: 0.5,
				scale: 0,
			})
			.from(".animation-effect .two-camps__pic.two-camps__pic-5", {
				// duration: 0.5,
				scale: 0,
			});
	} else {
		twoCampsAnimationTimeline.from([".animation-effect .two-camps__pic.two-camps__pic-1", ".animation-effect .two-camps__pic.two-camps__pic-2", ".animation-effect .two-camps__pic.two-camps__pic-3", ".animation-effect .two-camps__pic.two-camps__pic-4", ".animation-effect .two-camps__pic.two-camps__pic-5",], {
			// duration: 0.5,
			scale: 0,
		});
	}

	stToRefresh.push(twoCampsAnimationTimeline.scrollTrigger);

	// Moving photos trigger
	const twoCampsLowerGapper = document.querySelector(".js-two-camps-lower-gapper");
	twoCampsLowerGapper.classList.add("hidden");

	const twoCampsUpperGapper = document.querySelector(".js-two-camps-upper-gapper");
	twoCampsUpperGapper.classList.add("hidden");

	// Photos rows inside gappers
	const twoCampsLowerGapperRow = twoCampsLowerGapper.querySelector(".two-camps__pics-row");
	const twoCampsUpperGapperRow = twoCampsUpperGapper.querySelector(".two-camps__pics-row");

	// Container
	const twoCampsQuotesContainer = twoCampsLowerGapper.closest(".quotes-container");

	// First photo wrapper
	const firstPhotoQuoteWrapperEl = !helpers.isMobile() ? twoCampsQuotesContainer.querySelector(".quotes .quotes-img") : twoCampsQuotesContainer.querySelector(".quote-mobile-top");

	// First photo
	const firstPhotoQuoteEl = !helpers.isMobile() ? firstPhotoQuoteWrapperEl.querySelector("img") : firstPhotoQuoteWrapperEl.querySelectorAll("img");
	if (!helpers.isMobile()) {
		firstPhotoQuoteEl.classList.add("hidden");
	} else {
		firstPhotoQuoteEl.forEach((item) => {
			console.log(item)
			item.classList.add("hidden");
		});
	}

	// Fixed container in "animation-effect" fixed window
	const fixedTwoCampsPhotosWrapper = document.querySelector(".js-two-camps-fixed");

	// Photo container (to get sizes)
	const twoCampsPhotoContainer = twoCampsLowerGapper.querySelector(".two-camps__pic");

	// Calculate initial photos offset

	// Set photo container's height and offset
	twoCampsLowerGapper.style.height = window.innerHeight;
	twoCampsLowerGapper.style.top = `-${window.innerHeight}px`;

	twoCampsUpperGapper.style.height = window.innerHeight;
	twoCampsUpperGapper.style.top = `-${window.innerHeight}px`;
	if (helpers.isMobile()) {
		firstPhotoQuoteEl[0].classList.remove("hidden");

		twoCampsUpperGapperRow.classList.add("hidden");
	}

	const animationBlock3 = pirogovQuoteContainer.closest(".container").querySelector('.animation-block.js-person-effect');
	const positionTopScrollTrigger3 = animationBlock.getBoundingClientRect().height;
	// Moving pictures wrapper down
	const twoCampsMovingPhotoST = ScrollTrigger.create({
		trigger: twoCampsQuotesContainer,
		refreshPriority: 94,
		// start: (self) => self.previous().end,
		start: 'bottom, bottom',
		end: !helpers.isMobile() ? `start-=${window.innerHeight / 2 - twoCampsPhotoContainer.clientHeight / 2}` : `start-=${window.innerHeight / 2 - twoCampsPhotoContainer.clientHeight / 1.3}`,
		id: "photos",
		markers: false,
		scrub: true,
		invalidateOnRefresh: true,
		onEnter: () => {
			fixedTwoCampsPhotosWrapper.classList.add("hidden"); // fixed pic
			twoCampsLowerGapperRow.classList.add("two-camps__pics-row--animated"); // Animated picture's row
			twoCampsUpperGapperRow.classList.add("two-camps__pics-row--animated"); // Animated picture's row
			twoCampsLowerGapper.classList.remove("hidden");
			twoCampsUpperGapper.classList.remove("hidden");

			if (!helpers.isMobile()) {
				firstPhotoQuoteEl.classList.add("hidden");
			} else {
				firstPhotoQuoteEl.forEach((item) => {
					// item.classList.add("hidden");
				});
			}
		},
		onEnterBack: () => {
			twoCampsLowerGapperRow.classList.add("two-camps__pics-row--animated"); // Animated picture's row
			twoCampsUpperGapperRow.classList.add("two-camps__pics-row--animated"); // Animated picture's row

			if (!helpers.isMobile()) {
				firstPhotoQuoteEl.classList.add("hidden");
			} else {
				firstPhotoQuoteEl.forEach((item) => {
					// item.classList.add("hidden");
				});
			}
		},
		onLeaveBack: () => {
			fixedTwoCampsPhotosWrapper.classList.remove("hidden"); // fixed pic

			twoCampsLowerGapperRow.classList.remove("two-camps__pics-row--animated"); // Animated picture's row
			twoCampsUpperGapperRow.classList.remove("two-camps__pics-row--animated"); // Animated picture's row
			twoCampsLowerGapper.classList.add("hidden");
			twoCampsUpperGapper.classList.add("hidden");

			if (!helpers.isMobile()) {
				firstPhotoQuoteEl.classList.remove("hidden");
			} else {
				firstPhotoQuoteEl.forEach((item) => {
					item.classList.remove("hidden");
				});
			}
		},
		onLeave: () => {
			twoCampsLowerGapperRow.classList.remove("two-camps__pics-row--animated"); // Animated picture's row
			twoCampsUpperGapperRow.classList.remove("two-camps__pics-row--animated"); // Animated picture's row

			if (!helpers.isMobile()) {
				firstPhotoQuoteEl.classList.remove("hidden");
			} else {
				firstPhotoQuoteEl.forEach((item) => {
					item.classList.remove("hidden");
				});
			}
		},
		onUpdate(e) {
			objectMaterial.uniforms.uTwoCampsColorProgress.value = e.progress;
		},
	});
	stToRefresh.push(twoCampsMovingPhotoST);
	$('.quote-mobile-top').addClass('is-view');
	// ScrollTrigger for moving fake photos
	// Moving individual picture down
	const twoCampsPicsArr = twoCampsLowerGapper.querySelectorAll(".two-camps__pic");
	const twoCampsPicsArrLen = twoCampsPicsArr.length;
	const twoCampsPicOffsetGap = Math.round(window.innerHeight / 4);
	twoCampsPicsArr.forEach((twoCampsPic, index) => {
		gsap.to(twoCampsPic, {
			y: () => {
				// return Math.round(twoCampsPicOffsetGap / (twoCampsPicsArrLen - index)) * Math.sign(index);
			}, scrollTrigger: {
				trigger: twoCampsPic,
				refreshPriority: 93,
				start: (self) => self.previous().start,
				end: (self) => self.previous().end, // id: 'indi-pic',
				markers: false,
				scrub: true,
				invalidateOnRefresh: true,
				onUpdate(e) {
					if(e.progress === 1) {
						$('.quote-mobile-top').removeClass('is-view');

					} else {
						$('.quote-mobile-top').addClass('is-view');

					}
				},
			},

			onComplete: (e) => {

			}
		});
	});

	// Reset two camps ST
	// const twoCampsAnimationResetST = ScrollTrigger.create({
	// 	trigger: twoCampsEffectResetTriggerEl,
	// 	refreshPriority: 92,
	// 	start: "top top",
	// 	end: "bottom bottom",
	// 	// markers: false,
	// 	invalidateOnRefresh: true,
	// 	onLeave: () => {
	// 		objectMaterial.uniforms.uTwoCampsProgress.value = 0;
	// 	},
	// 	onEnterBack: () => {
	// 		objectMaterial.uniforms.uTwoCampsProgress.value = 1;
	// 		objectMaterial.uniforms.uIsDividingColors.value = 1.0;
	// 	},
	// });
	// stToRefresh.push(twoCampsAnimationResetST);

	/**
	 *  Two camps effect | Vernarskaya
	 **/
		//
	const vernarskayaAnimationTrigger = document.querySelector(".js-vernarskaya-effect");
	const vernarskayaEffectResetTriggerEl = document.querySelector(".js-reset-vernarskaya-effect");

	// Fixed photo in the fixed animation window
	const vernarskayaPicture = document.querySelector(".vernarskaya-block__pic");
	const vernarskayaPictureOverlay = vernarskayaPicture.querySelector(".vernarskaya-block__pic-overlay");

	// Parent container
	const vernarskayaQuoteBlock = document.querySelector(".quote-standart.js-vernarskaya");

	// Particles effect of "two camps"
	const vernarskayaParticlesTrigger = document.querySelector(".js-vernarskaya-particles");
	const vernarskayaParticlesST = ScrollTrigger.create({
		trigger: vernarskayaParticlesTrigger,
		refreshPriority: 85,
		start: "top top",
		end: `top+=${Math.round(window.innerHeight / 2)} top`, // id: 'particles',
		// markers: false,
		pin: true,
		invalidateOnRefresh: true,
		onUpdate(e) {
			// objectMaterial.uniforms.uTwoCampsProgress.value = e.progress;
			// objectMaterial.uniforms.uIsDividingColors.value = 0;
		},
		onLeave: () => {
			// objectMaterial.uniforms.uIsDividingColors.value = 0;
		},
		onEnter: () => {
			// objectMaterial.uniforms.uIsDividingColors.value = 0;
		},
	});
	stToRefresh.push(vernarskayaParticlesST);

	// Timeline for appearing center fixed photo
	const vernarskayaAnimationTimeline = gsap.timeline({
		scrollTrigger: {
			trigger: vernarskayaAnimationTrigger, refreshPriority: 84, invalidateOnRefresh: true, scrub: true, // start: self => ,
			start: "top+=10px top", end: "+=50%", pin: true, // id: "fix",
			markers: false, pinSpacing: true,
		},
	});

	const xPositionStart = helpers.isMobile() ? -100 : -200;

	gsap.set(vernarskayaPicture, {
		x: xPositionStart, scale: 0,
	});

	vernarskayaAnimationTimeline
		.fromTo(vernarskayaPicture, {
			x: xPositionStart, scale: 0,
		}, {
			// duration: 1,
			x: 0, scale: 1,
		}, 0)
		.fromTo(vernarskayaPictureOverlay, {
			autoAlpha: 1,
		}, {
			autoAlpha: 0,
		}, 0);

	stToRefresh.push(vernarskayaAnimationTimeline.scrollTrigger);

	// Moving photo effect | Vernarskaya ->
	const movingVernarskayaPictureTrigger = document.querySelector(".js-vernarskaya .js-person-gapper");
	movingVernarskayaPictureTrigger.classList.add("hidden");

	const vernarskayaQuoteContainer = movingVernarskayaPictureTrigger.closest(".quote-standart.js-moving-photo-effect");

	const fixedVernarskayaPicWrapper = document.querySelector(".vernarskaya-block__pic");

	const movingVernarskayaPicture = movingVernarskayaPictureTrigger.querySelector(".person__pic");

	// Calculate initial photos offset
	const initialVernarskayaOffset = window.innerHeight / 2 + movingVernarskayaPicture.clientHeight / 2;

	movingVernarskayaPictureTrigger.style.height = `${window.innerHeight}px`;
	movingVernarskayaPictureTrigger.style.top = `-${window.innerHeight}px`;

	// Trolley wrapper
	const trolleyWrapper = movingVernarskayaPictureTrigger.closest(".trolley");

	const animationBlock1 = vernarskayaQuoteBlock.closest(".container").querySelector('.animation-block.js-person-effect');
	window.addEventListener('load', () => {
		setTimeout(() => {
			const positionTopScrollTrigger1 = document.querySelector('.webgl').clientHeight;
			// console.log(positionTopScrollTrigger1, 'positionTopScrollTrigger1');

			// console.log(window.innerHeight / 2);
			// console.log(positionTopScrollTrigger1 / 2);

			// ScrollTrigger for moving photo of Vernarskaya
			const vernarskayaMovingPicST = ScrollTrigger.create({
				trigger: vernarskayaQuoteBlock, refreshPriority: 83, // 83
				// start: `start-=${positionTopScrollTrigger1 / 2} center`,
				// start: `start-=${window.innerHeight / 2} center`,
				start: helpers.isMobile() ? `start-=${positionTopScrollTrigger1 / 2} start+=${positionTopScrollTrigger1 / 2}` : `start-=${window.innerHeight / 2} center`, // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
				end: helpers.isMobile() ? `start-=${window.innerHeight / 2 - movingPirogovPicture.clientHeight / 2.5 + 6}` : `start-=${window.innerHeight / 2 - movingPirogovPicture.clientHeight / 2.5}`,

				// start: `start-=${window.innerHeight / 2} center`, // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
				// end: helpers.isMobile() ? `start-=${window.innerHeight / 2 - movingPirogovPicture.clientHeight / 2.5 + 6}` : `start-=${window.innerHeight / 2 - movingPirogovPicture.clientHeight / 2.5}`,
				// id: "vernarskayaыы",
				markers: false,
				scrub: true, invalidateOnRefresh: true, onEnter: () => {
					fixedVernarskayaPicWrapper.classList.add("hidden"); // fixed pic
					movingVernarskayaPicture.classList.add("person__pic--animated"); // Animated picture
					movingVernarskayaPictureTrigger.classList.remove("hidden");
				}, onEnterBack: () => {
					movingVernarskayaPicture.classList.add("person__pic--animated"); // Animated picture
				}, onLeaveBack: () => {
					fixedVernarskayaPicWrapper.classList.remove("hidden"); // fixed pic
					movingVernarskayaPicture.classList.add("person__pic--animated"); // Animated picture
					movingVernarskayaPictureTrigger.classList.add("hidden");
				}, onLeave: () => {
					movingVernarskayaPicture.classList.remove("person__pic--animated"); // Animated picture
				}, onToggle: ({isActive}) => {
					if (isActive === true) {
						trolleyWrapper.classList.add("trolley-custom");
					} else {
						trolleyWrapper.classList.remove("trolley-custom");
					}
				},
			});
			stToRefresh.push(vernarskayaMovingPicST);

			// Person effect | Vernarskaya <-

			// Reset progress
			const resetVernarskayaAnimationST = ScrollTrigger.create({
				trigger: vernarskayaEffectResetTriggerEl, refreshPriority: 82, start: "top top", end: "bottom bottom", // markers: false,
				id: "vernasrkaya", invalidateOnRefresh: true, onLeave: () => {
					vernarskayaPicture.classList.add("vernarskaya-block__pic-hidden");

					// objectMaterial.uniforms.uTwoCampsProgress.value = 0;
				}, onEnterBack: () => {
					vernarskayaPicture.classList.remove("vernarskaya-block__pic-hidden");

					// objectMaterial.uniforms.uTwoCampsProgress.value = 1;
				},
			});
			stToRefresh.push(resetVernarskayaAnimationST);
		}, 0);
	})


	// **** //
	/**
	 *  Two camps effect | korsini
	 **/

	const korsiniAnimationTrigger = document.querySelector(".js-korsini-effect");
	const korsiniEffectResetTriggerEl = document.querySelector(".js-reset-korsini-effect");
	// Fixed photo in the fixed animation window
	const korsiniPicture = document.querySelector(".korsini-block__pic");
	const korsiniPictureOverlay = korsiniPicture.querySelector(".korsini-block__pic-overlay");
	// const korsiniFilter = document.querySelector(".korsini-filter");

	const orangePoints = document.querySelector(".orange-points");
	// Parent container

	const korsiniQuoteBlock = document.querySelector(".quote-header.js-korsini");
	// Particles effect of "two camps"
	const korsiniParticlesTrigger = document.querySelector(".trolley--2");

	// const korsiniParticlesST = ScrollTrigger.create({
	// 	trigger: korsiniParticlesTrigger,
	// 	refreshPriority: 85,
	// 	start: `bottom bottom`,
	// 	end: `top+=${Math.round(window.innerHeight / 4)} top`,
	// 	id: "particles", // markers: false,
	// 	pin: true,
	// 	invalidateOnRefresh: true,
	// 	onUpdate(e) {
	// 		objectMaterial.uniforms.korsini.value = e.progress;
	// 		objectMaterial.uniforms.uIsDividingColorsKorsini.value = 1.0;
	// 		objectMaterial.uniforms.korsiniColorProgress.value = e.progress;
	// 	},
	// 	onLeave: () => {
	// 		objectMaterial.uniforms.uIsDividingColorsKorsini.value = 1.0;
	// 	},
	// 	onEnter: () => {
	// 		objectMaterial.uniforms.uIsDividingColorsKorsini.value = 1.0;
	// 	},
	// });
	// stToRefresh.push(korsiniParticlesST);

	// Timeline for appearing center fixed photo
	setTimeout(() => {
		const korsiniAnimationTimeline = gsap.timeline({
			scrollTrigger: {
				trigger: korsiniAnimationTrigger,
				refreshPriority: 84,
				invalidateOnRefresh: true,
				scrub: true, // start: self => ,
				start: !helpers.isMobile() ? `210% 210%` : `start-=30% start-=30%`, // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
				end: !helpers.isMobile() ? `280% 280%` : 'start+=30% start+=30%',
				// end: `start+=${korsiniAnimationTrigger.offsetTop}`, // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
				// start: `start+=${korsiniAnimationTrigger.offsetTop + korsiniAnimationTrigger.innerHeight * 2}`,
				id: "korsini-2",
				markers: false,
				onUpdate(e) {
					// objectMaterial.uniforms.uTwoCampsProgress.value = e.progress;
					objectMaterial.uniforms.uIsDividingColors.value = 1.0;
				}, onLeave: () => {
					objectMaterial.uniforms.uIsDividingColors.value = 1.0;
				}, onEnter: () => {
					objectMaterial.uniforms.uIsDividingColors.value = 1.0;
				}, onEnterBack: () => {
					objectMaterial.uniforms.uIsDividingColors.value = 1.0;
				},
			},
		});

		const korsiniAnimationTimeline2 = gsap.timeline({
			scrollTrigger: {
				trigger: korsiniAnimationTrigger,
				refreshPriority: 85,
				invalidateOnRefresh: true,
				scrub: true, // start: self => ,
				start: !helpers.isMobile() ? `440% 440%` : `start+=30% start+=30%`, // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
				end: !helpers.isMobile() ? `610% 610%` : 'start+=120% start+=120%',
				// start: `start+=${window.innerHeight * 3.7} center`, // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
				// end: `start+=${window.innerHeight * 3.9}`,
				id: "korsini",
				markers: false,
			},
		});

		gsap.set(korsiniPicture, {
			x: window.innerWidth < 1590 ? '-80%' : !helpers.isMobile() ? '-100%' : '-60%', // y: 50,
			// x: window.innerWidth < 1590 ? '-55%' : !helpers.isMobile() ? '-100%' : '-60%', // y: 50,
			scale: 0,
		});

		korsiniAnimationTimeline
			.fromTo(orangePoints, {
				x: "-60%", y: "-50%",
				visibility: "hidden",
			}, {
				x: "-51%", y: "-50%",
				visibility: "visible"
			},)

		korsiniAnimationTimeline2.fromTo(korsiniPictureOverlay, {
			autoAlpha: 1,
		}, {
			autoAlpha: 0,
		}, 0).to(korsiniPicture, {})

		korsiniAnimationTimeline2.fromTo(korsiniPicture, {
			x: window.innerWidth < 1590 ? '-80%' : !helpers.isMobile() ? '-100%' : '-60%', // y: 50,
			scale: 0,
		}, {
			x: "0",
			scale: 1,
		}, 0);
		stToRefresh.push(korsiniAnimationTimeline.scrollTrigger);
		stToRefresh.push(korsiniAnimationTimeline2.scrollTrigger);
	}, 0)

	// Moving photo effect | korsini ->
	// const movingkorsiniPictureTrigger = document.querySelector('.js-korsini .js-person-gapper');
	// movingkorsiniPictureTrigger.classList.add('hidden');
	//
	// const korsiniQuoteContainer = movingkorsiniPictureTrigger.closest('.quote-standart.js-moving-photo-effect');
	//
	const fixedkorsiniPicWrapper = document.querySelector(".korsini-block__pic");
	//
	// const movingkorsiniPicture = movingkorsiniPictureTrigger.querySelector('.person__pic');
	//
	// // Calculate initial photos offset
	// const initialkorsiniOffset = window.innerHeight / 2 + movingkorsiniPicture.clientHeight / 2;
	//
	// movingkorsiniPictureTrigger.style.height = `${window.innerHeight}px`;
	// movingkorsiniPictureTrigger.style.top = `-${window.innerHeight}px`;

	// Trolley wrapper
	// const trolleyWrapper2 = movingkorsiniPictureTrigger.closest('.trolley--2');

	// ScrollTrigger for moving photo of korsini
	// const korsiniMovingPicST = ScrollTrigger.create({
	// 	trigger: korsiniQuoteBlock,
	// 	refreshPriority: 83, // 83
	// 	start: `bottom bottom`,
	// 	end: `bottom bottom`,
	// 	// start: `start+=${window.innerHeight * 2} center`,
	// 	// end: `start+=${fixedkorsiniPicWrapper.clientHeight / 3} center`,
	// 	// start: self => self.previous().end,
	// 	// end: `start-=${(window.innerHeight / 2 - fixedkorsiniPicWrapper.clientHeight / 2)}`,
	// 	id: "korsini",
	// markers: true,
	// 	scrub: true,
	// 	invalidateOnRefresh: true,
	// 	// onUpdate(e) {
	// 	// 	// objectMaterial.uniforms.korsiniColorProgress.value = e.progress;
	// 	// 	// objectMaterial.uniforms.korsini.value = e.progress;
	// 	// 	// objectMaterial.uniforms.uIsDividingColors.value = 1.0;
	// 	// },
	// 	// onLeave: () => {
	// 	// 	// objectMaterial.uniforms.uIsDividingColors.value = 1.0;
	// 	// },
	// 	// onEnter: () => {
	// 	// 	// objectMaterial.uniforms.uIsDividingColors.value = 1.0;
	// 	// },
	// 	// onEnterBack: () => {
	// 	// 	// objectMaterial.uniforms.uIsDividingColors.value = 1.0;
	// 	// },
	// 	onEnter: () => {
	// 		korsiniPicture.classList.remove('hidden'); // fixed pic
	//
	// 	},
	// 	onEnterBack: () => {
	// 		korsiniPicture.classList.add('hidden'); // fixed pic
	// 	},
	// 	onLeaveBack: () => {
	// 		korsiniPicture.classList.remove('hidden'); // fixed pic
	// 	},
	// 	onLeave: () => {
	// 		korsiniPicture.classList.add('hidden'); // fixed pic
	// 	},
	// 	// onToggle: ({ isActive }) => {
	// 	// 	if (isActive === true) {
	// 	// 		trolleyWrapper.classList.add('trolley-custom');
	// 	// 	} else {
	// 	// 		trolleyWrapper.classList.remove('trolley-custom');
	// 	// 	}
	// 	// },
	// });
	// stToRefresh.push(korsiniMovingPicST);

	// Person effect | korsini <-
	//
	// Reset progress
	const resetkorsiniAnimationST = ScrollTrigger.create({
		trigger: korsiniEffectResetTriggerEl, refreshPriority: 82, start: "top top", end: "bottom bottom",
		markers: false,
		id: "korsini", invalidateOnRefresh: true, onLeave: () => {
			korsiniPicture.classList.add("korsini-block__pic-hidden");

			objectMaterial.uniforms.korsini.value = 0;
		}, onEnterBack: () => {
			korsiniPicture.classList.remove("korsini-block__pic-hidden");

			objectMaterial.uniforms.korsini.value = 1;
		},
	});
	stToRefresh.push(resetkorsiniAnimationST);

	const revoAnimationTrigger = document.querySelector(".js-revo-effect");
	const revoEffectResetTriggerEl = document.querySelector(".js-reset-revo-effect");
	// Fixed photo in the fixed animation window


	// const revoFilter = document.querySelector(".revo-filter");
	// Parent container

	const revoQuoteBlock = document.querySelector(".quote-header.js-revo");
	// Particles effect of "two camps"
	const revoParticlesTrigger = document.querySelector(".trolley--2");

	const revoAnimationTimeline = gsap.timeline({
		scrollTrigger: {
			trigger: revoAnimationTrigger,
			refreshPriority: 84,
			invalidateOnRefresh: true,
			scrub: true, // start: self => ,
			start: !helpers.isMobile() ? `start+=2060%` : `start+=2180%`, // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
			end: !helpers.isMobile() ? `start+=2230%` : `start+=2435%`,
			// start: `start+=${window.innerHeight * 10} center`, // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
			// end: `start+=${window.innerHeight * 15}`,
			id: "revo-2",
			markers: false,
			onLeave: () => {
				console.log('enter revo')
			}, onEnterBack: () => {
				console.log('enter revo')
			},
			onEnter: () => {
				console.log('enter revo')
			}
		},
	});

	const orangePoints2 = document.querySelector(".orange-points-2");

	revoAnimationTimeline
		.fromTo(orangePoints2, {
			x: "-65%", y: "-50%",
			rotate: 20,
			visibility: "hidden",
		}, {
			x: "-51%", y: "-52%",
			rotate: 0,
			visibility: "visible"
		},)

	stToRefresh.push(revoAnimationTimeline.scrollTrigger);

	//
	// Reset progress
	const resetrevoAnimationST = ScrollTrigger.create({
		trigger: revoEffectResetTriggerEl, refreshPriority: 82, start: "top top", end: "bottom bottom", // markers: false,
		id: "revo", invalidateOnRefresh: true,
		onLeave: () => {

		}, onEnterBack: () => {

		},
	});
	stToRefresh.push(resetrevoAnimationST);

	const politAnimationTrigger = document.querySelector(".js-polit-effect");
	const politEffectResetTriggerEl = document.querySelector(".js-reset-polit-effect");
	const orangePoints3 = document.querySelector(".orange-points-2");
	const orangePoints4 = document.querySelector(".orange-points-4");
	const orangePoints5 = document.querySelector(".orange-points-5");


	// Timeline for appearing center fixed photo
	const politAnimationTimeline = gsap.timeline({
		scrollTrigger: {
			trigger: politAnimationTrigger,
			refreshPriority: 123123123,
			invalidateOnRefresh: true,
			scrub: true, // start: self => ,
			// start: !helpers.isMobile() ? `start+=${(200 - window.innerHeight) / 0.1}%` : `start+=${(69 - window.innerHeight) / 0.1}%`,
			start: !helpers.isMobile() ? `start+=2090%` : `start+=780%`,
			// start: !helpers.isMobile() ? `start+=2000%` : `start+=690%`,
			// end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
			// end: !helpers.isMobile() ? `start+=2080%` : `start+=760%`,
			end: !helpers.isMobile() ? `start+=2150%` : `start+=800%`,
			// start: `start+=10%`, // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
			// end: `start+=50%`,
			id: "polit-4",
			markers: false,
			onLeave: () => {
				console.log('enter polit')
			}, onEnterBack: () => {
				console.log('enter polit')
			},
			onEnter: () => {
				console.log('enter polit')
			},
			onUpdate: (e) => {
				// console.log(e.progress)
				if (e.progress > 0.7) {
					orangePoints4.setAttribute('stage', '2')
				} else {
					orangePoints4.setAttribute('stage', '1')
				}
			}
		},
	});

	gsap.set(orangePoints4, {
		x: !helpers.isMobile() ? "-49%" : '-47%', y: !helpers.isMobile() ? "-41%" : '-44%',
		rotate: !helpers.isMobile() ? -10 : -18,
	});

	// transform: translate(-49%, -41%) rotate(-10deg);
	politAnimationTimeline
		.fromTo(orangePoints3, {
			x: "-49%", y: "-50%",
			rotate: 0,
		}, {
			x: "-65%", y: "-50%",
			rotate: 20,
		},)
		.fromTo(orangePoints4, {
			x: !helpers.isMobile() ? "-49%" : '-47%', y: !helpers.isMobile() ? "-41%" : '-44%',
			rotate: !helpers.isMobile() ? -10 : -18,

		}, {
			x: "-49%", y: "-50%",
			rotate: 0,
		},)

	stToRefresh.push(politAnimationTimeline.scrollTrigger);
	// stToRefresh.push(politAnimationTimeline2.scrollTrigger);
	// stToRefresh.push(politAnimationTimeline3.scrollTrigger);


	const lastParticlesTrigger = document.querySelector(".js-last-particles");
	const lastAnimationTrigger = document.querySelector(".js-last-trigger");
	const mask = document.querySelector(".js-filter");
	const lastParticlesST = ScrollTrigger.create({
		trigger: lastParticlesTrigger,
		refreshPriority: 96,
		invalidateOnRefresh: true,
		start: window.innerWidth > 1800 ? 'start+=5640%' : window.innerWidth < 376 ? 'start+=2620%' : !helpers.isMobile() ? `start+=5440%` : 'start+=2420%', // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
		end: window.innerWidth > 1800 ? 'start+=5770%' : window.innerWidth < 376 ? 'start+=2720%' : !helpers.isMobile() ? `start+=5670%` : 'start+=2520%',
		id: "shape-last",
		markers: false,
		pin: false,
		// invalidateOnRefresh: true,
		onUpdate(e) {
			console.log('progress', e.progress)
			objectMaterial.uniforms.uTwoCampsProgress.value = -(-1 + e.progress);
			objectMaterial.uniforms.uIsDividingColors.value = 0;

			if (e.progress === 1) {
				helpers.$document.trigger('particle-color-orange');
			} else {
				helpers.$document.trigger('particle-color-black');
			}
		},
		onLeave: () => {
			objectMaterial.uniforms.uIsDividingColors.value = 0;
		},
		onEnter: () => {
			canvas.classList.add('is-last');
			objectMaterial.uniforms.uIsDividingColors.value = 0;
		},
		onEnterBack: () => {
			canvas.classList.add('is-last');
			objectMaterial.uniforms.uIsDividingColors.value = 0;
		},
	});


	stToRefresh.push(lastParticlesST);

	const lastAnimationTimeline = gsap.timeline({
		scrollTrigger: {
			trigger: !helpers.isMobile() ? lastAnimationTrigger : lastParticlesTrigger,
			refreshPriority: 105,
			invalidateOnRefresh: true,
			scrub: true, // start: self => ,
			start: window.innerWidth > 1800 ? 'start+=3850%' : window.innerWidth < 376 ? 'start+=2820%' : !helpers.isMobile() ? `start+=3650%` : 'start+=2600%', // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
			end: window.innerWidth > 1800 ? 'start+=4050%' : window.innerWidth < 376 ? 'start+=2920%' : !helpers.isMobile() ? `start+=3850%` : 'start+=2790%',
			// start: `start+=10%`, // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
			// end: `start+=50%`,
			id: "last-4",
			pin: false,
			onEnter: () => {
				console.log('enter')
			},
			markers: false,
		},
	});

	const lastAnimationTimeline2 = gsap.timeline({
		scrollTrigger: {
			trigger: !helpers.isMobile() ? lastAnimationTrigger : lastParticlesTrigger,
			refreshPriority: 105,
			invalidateOnRefresh: true,
			scrub: true, // start: self => ,
			start: window.innerWidth > 1800 ? 'start+=3800%' : window.innerWidth < 376 ? 'start+=2820%' : !helpers.isMobile() ? `start+=3700%` : 'start+=2600%', // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
			end: window.innerWidth > 1800 ? 'start+=4050%' : window.innerWidth < 376 ? 'start+=2920%' : !helpers.isMobile() ? `start+=3950%` : 'start+=2790%',
			// start: `start+=10%`, // end: `start+=${fixedVernarskayaPicWrapper.clientHeight / 2} center`, // start: self => self.previous().end,
			// end: `start+=50%`,
			id: "last-4",
			pin: false,
			onEnter: () => {
				console.log('enter')
			},
			markers: false,
		},
	});

	lastAnimationTimeline
		.fromTo([orangePoints4, orangePoints5], {
			x: "-49%", y: "-50%",
		}, {
			x: "-55%", y: "-50%",
		},)
		.fromTo([orangePoints3, orangePoints4, orangePoints5], {
			opacity: 1
		}, {
			opacity: 0
		},)
	lastAnimationTimeline2.fromTo(mask, {
			opacity: 0
		}, {
			opacity: 1
		},)


	stToRefresh.push(lastAnimationTimeline);
	stToRefresh.push(lastAnimationTimeline2);
	//
	// Reset progress
	// const resetpolitAnimationST = ScrollTrigger.create({
	// 	trigger: politEffectResetTriggerEl, refreshPriority: 82, start: "top top", end: "bottom bottom", // markers: false,
	// 	id: "polit", invalidateOnRefresh: true,
	// 	onLeave: () => {
	//
	// 	}, onEnterBack: () => {
	//
	// 	},
	// });
	// stToRefresh.push(resetpolitAnimationST);
	/**
	 *  ACTIVATE CHARTS ANIMATION ->
	 **/
	let chartSTToRefresh = [];

	// Init circles charts (made via dom-elements)
	circlesCharts.init();
	barCharts.init();

	// Custom chart animation
	chartSTToRefresh = initChartsAnimation();
	stToRefresh.push(...chartSTToRefresh);


	if (!helpers.isMobile()) {
		videoLoader.init({timeOut: 1800});
	}

	// fixedSection();
	window.addEventListener('load', () => {
		// setstylePersone(sizes);
		setTimeout(() => {
			if (!helpers.isMobile()) {
				fixedSection();
			}
		}, 2000);
	})
};

export default {
	init,
};
/* eslint-enable */
